import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { FiMaximize2, FiArrowLeft, FiPlus, FiSave, FiDownload, FiCalendar, FiTrash2, FiChevronDown, FiFileText } from 'react-icons/fi';
import Modal from '../../Components/UI/Modal';
import { DROPDOWN_Z, NESTED_MODAL_Z } from '../../Components/CommonComponents/ModalPortal';
import CustomBreadcrumbs from '../../Components/CommonComponents/CustomBreadcrumbs';
import CustomTextarea from '../../Components/CommonComponents/CustomTextarea';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { UploadFile, addNewPrescription, getAllPatientPrescription, getSinglePatient, END_POINT, RemoveFile, getSinglePatientFetch, UploadImages, DeleteImages, getJwtToken, setClinicProfile } from '../../Redux/AdminReducer/action';
import CustomSpinner from '../../Components/CommonComponents/CustomSpinner';
import PaginationButtons from '../../Components/CommonComponents/PaginationButtons';
import { useFetcher, useNavigate, useParams } from 'react-router-dom';
import { FileUploadModal, ImageShowModal, ImageUploadModal } from '../../Components/CommonComponents/PrescriptionUploadModal';
import CustomSelect, { CustomSelectForPrescrption } from '../../Components/CommonComponents/CustomSelect';
import SearchableSelect from '../../Components/CommonComponents/SearchableSelect';
import CustomInput from '../../Components/CommonComponents/CustomInput';
import format from 'date-fns/format';
import { FaRegStar, FaStar } from 'react-icons/fa';
import { treatmentStatusOptions, visitStatusOptions } from '../../Files/dropdownOptions';
import axios from 'axios';
import { getDateFormat } from '../../functions';
import { getAllMedicines } from '../../Redux/Store/API/Medicines';
import { postCustomFieldtoPatients } from '../../Redux/Store/API/Patients'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import { getAllDropDowns } from '../../Redux/Store/API/DropDownApi';
import { useLinkedDropdown, resolveChildSelection } from '../../Services/linkedDropdowns';
import CreatableSelect from "react-select/creatable";
import { BaseUrl } from '../DropDown';
import VitalSignsModal from '../../Components/CommonComponents/VitalSignsModal';
import { useSpeechToText } from '../../hooks/useSpeechToText';
import { fetchLabRequests, resendLabRequest, openLabDocument, createReferralBusiness, BUSINESS_TYPES as REFERRAL_BUSINESS_TYPES } from '../../Services/referralBusiness';
import { getProfileCompletion, deriveAgeGroup } from '../../Services/patientCompletion';

const safeFormatDate = (dateVal, formatStr = 'dd/MM/yyyy', fallback = '-') => {
  if (!dateVal) return fallback;
  const d = new Date(dateVal);
  if (!isNaN(d.getTime())) return format(d, formatStr);
  if (typeof dateVal === 'string') {
    const parts = dateVal.split(/[-/]/);
    if (parts.length === 3) {
      const parsed = parts[0].length === 4
        ? new Date(parts[0], parts[1] - 1, parts[2])
        : new Date(parts[2], parts[1] - 1, parts[0]);
      if (!isNaN(parsed.getTime())) return format(parsed, formatStr);
    }
  }
  return String(dateVal || fallback);
};

const getSafeTime = (d) => {
  if (!d) return 0;
  const t = new Date(d).getTime();
  return isNaN(t) ? 0 : t;
};

const deletePrescription = async (data) => {
  try {
    const result = await axios.delete(`${END_POINT}/prescription/delete/${data}`, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    toast.dismiss();
    toast.success('record deleted Successfully');
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  } catch (error) {
    toast.dismiss();
    const data = error?.response?.data;
    toast.error(typeof data === 'string' ? data : data?.error || data?.message || 'could not delete');
  }
};

// navigator.clipboard only exists on HTTPS / localhost, so fall back to a
// hidden textarea when the admin is opened over plain HTTP.
const copyLink = async (link) => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(link);
    } else {
      const el = document.createElement('textarea');
      el.value = link;
      el.setAttribute('readonly', '');
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(el);
      if (!ok) throw new Error('copy failed');
    }
    toast.success('Link copied to clipboard!', { position: toast.POSITION.TOP_RIGHT });
  } catch (err) {
    // Still give the user the link so it can be copied by hand.
    window.prompt('Copy this link:', link);
  }
};



const initialFormData = {
  Date: '',
  Symptoms: '',
  MedicinePrescription: { 0: { name: '', duration: '2 weeks' } },
  SupplimentoryMedicine: { 0: { name: '', duration: '', fees: '' } },
  PathologicalTests: { 0: { name: '', referredTo: '', amount: '', remarks: '' } },
  ReportsPrescription: '',
  Suggestions: '',
  ProbableTreatment: '',
  Other: '',
  doctorId: '',
  PreviousReportNotes: '',
  PreviousTreatmentNotes: '',
  PreviousPicturesNotes: '',
  CourierDetails: {},
  PaymentDetails: {},
  PaymentMode: '',
  ReceivedBy: '',
  total: '',
  paid: '',
  CaseRating: '',
  CaseMark: '',
  ReviewMark: '',
  Patient_Type: '',
  remaining: '',
  others_1_label: '',
  others_2_label: '',
  others_3_label: '',
  consultation_charges: '',
  followup_medicine_charges: '',
  supplementary_charges: '',
  previous_balance_deposits: '',
};

const calculateAge = (dob) => {
  if (!dob) return null;
  const birth = new Date(dob);
  if (isNaN(birth.getTime())) return null;
  const diff = Date.now() - birth.getTime();
  return Math.abs(new Date(diff).getUTCFullYear() - 1970);
};

const mapToRows = (mapObj) => {
  if (!mapObj) return [];
  return Object.values(mapObj).filter(
    (row) => row && Object.values(row).some((v) => v !== '' && v != null)
  );
};

const printCellStyle = { padding: '5px', border: '1px solid #e2e8f0' };

const PrintSection = ({ title, children }) => (
  <div style={{ marginBottom: '14px', breakInside: 'avoid' }}>
    <div
      style={{
        fontSize: '12px',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: '#0f172a',
        borderBottom: '1px solid #cbd5e1',
        paddingBottom: '4px',
        marginBottom: '6px',
      }}
    >
      {title}
    </div>
    <div style={{ fontSize: '12px', color: '#1e293b', lineHeight: 1.5 }}>{children}</div>
  </div>
);

// Clean, purpose-built printable layout — deliberately NOT the interactive edit
// form (which is a screenshot of on-screen inputs/buttons). This is what actually
// gets captured into the downloaded PDF.
// Printable margin applied to every page of the generated prescription PDF.
const PDF_MARGIN_MM = 12;

const PrescriptionPrintTemplate = ({ entry, patient, clinicProfile, doctorName }) => {
  if (!entry) return null;

  const clinicData = clinicProfile?.data || {};
  const logo = clinicProfile?.imageData;

  const medicines = mapToRows(entry.MedicinePrescription);
  const supplements = mapToRows(entry.SupplimentoryMedicine);
  const tests = mapToRows(entry.PathologicalTests);
  const age = calculateAge(patient?.dateOfBirth);

  return (
    <div style={{ width: '794px', padding: '32px', fontFamily: 'Arial, Helvetica, sans-serif', background: '#ffffff', color: '#0f172a' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '3px solid #0ea5e9', paddingBottom: '12px', marginBottom: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {logo && (
            <img src={`data:image/jpeg;base64,${logo}`} alt="Clinic Logo" style={{ width: '56px', height: '56px', objectFit: 'contain', borderRadius: '8px' }} />
          )}
          <div>
            <div style={{ fontSize: '18px', fontWeight: 800 }}>{clinicData.ClinicName || 'Clinic Name'}</div>
            <div style={{ fontSize: '12px', color: '#475569' }}>Dr. {clinicData.DoctorName || doctorName || ''}</div>
          </div>
        </div>
        <div style={{ textAlign: 'right', fontSize: '11px', color: '#475569' }}>
          {clinicData.ClinicContact && <div>Phone: {clinicData.ClinicContact}</div>}
          {clinicData.ClinicEmail && <div>Email: {clinicData.ClinicEmail}</div>}
        </div>
      </div>

      {/* Title + Date */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div style={{ fontSize: '14px', fontWeight: 700, letterSpacing: '0.08em' }}>PRESCRIPTION</div>
        <div style={{ fontSize: '12px', fontWeight: 600 }}>Visit Date: {safeFormatDate(entry?.Date)}</div>
      </div>

      {/* Patient Basic Details */}
      <PrintSection title="Patient Details">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 24px' }}>
          <div><b>Name:</b> {[patient?.firstName, patient?.surname].filter(Boolean).join(' ') || '-'}</div>
          <div><b>Patient ID:</b> {patient?.customerId || '-'}</div>
          <div><b>Gender:</b> {patient?.gender || '-'}</div>
          <div><b>Age:</b> {age != null ? `${age} years` : '-'}</div>
          <div><b>Mobile:</b> {patient?.mobile || '-'}</div>
          <div><b>Location:</b> {patient?.location || '-'}</div>
        </div>
      </PrintSection>

      {entry.Symptoms && (
        <PrintSection title="History">
          <div style={{ whiteSpace: 'pre-wrap' }}>{entry.Symptoms}</div>
        </PrintSection>
      )}

      {entry.PreviousTreatmentNotes && (
        <PrintSection title="Previous Treatment">
          <div style={{ whiteSpace: 'pre-wrap' }}>{entry.PreviousTreatmentNotes}</div>
        </PrintSection>
      )}

      {(entry.PreviousReportNotes || entry.ReportsPrescription) && (
        <PrintSection title="Reports">
          {entry.PreviousReportNotes && <div style={{ whiteSpace: 'pre-wrap', marginBottom: '4px' }}>{entry.PreviousReportNotes}</div>}
          {entry.ReportsPrescription && <div style={{ whiteSpace: 'pre-wrap' }}><b>Reports Advised:</b> {entry.ReportsPrescription}</div>}
        </PrintSection>
      )}

      {(entry.Suggestions || entry.ProbableTreatment || entry.Other) && (
        <PrintSection title="Suggestions & Advice">
          {entry.Suggestions && <div style={{ whiteSpace: 'pre-wrap', marginBottom: '4px' }}>{entry.Suggestions}</div>}
          {entry.ProbableTreatment && <div style={{ whiteSpace: 'pre-wrap', marginBottom: '4px' }}><b>Likely Treatment Plan:</b> {entry.ProbableTreatment}</div>}
          {entry.Other && <div style={{ whiteSpace: 'pre-wrap' }}><b>Other Notes:</b> {entry.Other}</div>}
        </PrintSection>
      )}

      {medicines.length > 0 && (
        <PrintSection title="Medicines to Take">
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
            <thead>
              <tr style={{ background: '#f1f5f9', textAlign: 'left' }}>
                <th style={printCellStyle}>Medicine</th>
                <th style={printCellStyle}>Potency</th>
                <th style={printCellStyle}>Duration</th>
                <th style={printCellStyle}>How to Take</th>
              </tr>
            </thead>
            <tbody>
              {medicines.map((m, i) => (
                <tr key={i}>
                  <td style={printCellStyle}>{m.name || '-'}</td>
                  <td style={printCellStyle}>{m.potency || '-'}</td>
                  <td style={printCellStyle}>{m.duration || '-'}</td>
                  <td style={printCellStyle}>{m.intake || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </PrintSection>
      )}

      {supplements.length > 0 && (
        <PrintSection title="Additional Medicines">
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
            <thead>
              <tr style={{ background: '#f1f5f9', textAlign: 'left' }}>
                <th style={printCellStyle}>Medicine</th>
                <th style={printCellStyle}>Duration</th>
                <th style={printCellStyle}>How to Take</th>
                <th style={printCellStyle}>Qty</th>
              </tr>
            </thead>
            <tbody>
              {supplements.map((m, i) => (
                <tr key={i}>
                  <td style={printCellStyle}>{m.name || '-'}</td>
                  <td style={printCellStyle}>{m.duration || '-'}</td>
                  <td style={printCellStyle}>{m.intake || '-'}</td>
                  <td style={printCellStyle}>{m.quantity || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </PrintSection>
      )}

      {tests.length > 0 && (
        <PrintSection title="Lab Tests Advised">
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
            <thead>
              <tr style={{ background: '#f1f5f9', textAlign: 'left' }}>
                <th style={printCellStyle}>Test</th>
                <th style={printCellStyle}>Referred To</th>
                <th style={printCellStyle}>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {tests.map((t, i) => (
                <tr key={i}>
                  <td style={printCellStyle}>{t.name || '-'}</td>
                  <td style={printCellStyle}>{t.referredTo || '-'}</td>
                  <td style={printCellStyle}>{t.remarks || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </PrintSection>
      )}

      {/* Footer */}
      <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', borderTop: '1px solid #cbd5e1', paddingTop: '12px' }}>
        <div style={{ fontSize: '10px', color: '#64748b', maxWidth: '420px' }}>
          Generated on {format(new Date(), 'dd/MM/yyyy')}. This is a computer-generated prescription. Please contact the clinic for any queries.
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '160px', borderTop: '1px solid #0f172a', marginBottom: '4px' }} />
          <div style={{ fontSize: '11px', fontWeight: 600 }}>Dr. {clinicData.DoctorName || doctorName || ''}</div>
        </div>
      </div>
    </div>
  );
};

// Ring version of the Modify Patient completion figure, with the percentage
// alongside it so the header stays compact.
const CompletionRing = ({ percent = 0, size = 22 }) => {
  const value = Math.max(0, Math.min(100, Number(percent) || 0));
  const stroke = 3.5;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const colour = value === 100 ? '#10b981' : value >= 60 ? '#0ea5e9' : '#f59e0b';

  return (
    <span className="inline-flex items-center gap-1.5" title={`Patient record ${value}% complete`}>
      <svg width={size} height={size} className="-rotate-90 shrink-0">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#e2e8f0" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={colour}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - (circumference * value) / 100}
          style={{ transition: 'stroke-dashoffset 300ms ease' }}
        />
      </svg>
      <span className="text-xs font-bold text-slate-700">{value}%</span>
    </span>
  );
};

const AddPrescription = () => {

  const [visibleDate, setVisibleDate] = useState(getDateFormat(new Date()));
  const [formData, setFormData] = useState(null);
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  const [printDate, setPrintDate] = useState(null);
  const printTemplateRef = useRef(null);
  const updateFormRef = useRef([]);
  let { patientId } = useParams();
  const { userLogindata } = useSelector((state) => state.AuthReducer);

  const [formError, setFormError] = useState({ ...initialFormData });
  const formDataRef = useRef([{ ...formData }]);
  const [paginate, setpaginate] = useState({ page: 1, pageSize: 10 });
  let { singlePatientData, updatePrescriptionProcessing, updatePrescriptionSuccess, updatePrescriptionFail, updatePrescriptionMessage, getAllPrescriptionData } = useSelector((state) => state.AdminReducer);
  const scrollContainerRef = useRef(null);
  const [patientUpdate, setPatientUpdate] = useState(null);
  const patientUpdateRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setClinicProfile());
  }, []);

  const clinicProfile = useSelector((state) => state?.AdminReducer.clinicProfile);

  // Whoever is logged in is the one taking the payment, so "Received By" defaults
  // to their name. Every role's login returns `name`; the rest are fallbacks so the
  // box is never left blank just because an account record is shaped differently.
  const loggedIn = userLogindata?.data;
  const signedInName =
    loggedIn?.name ||
    [loggedIn?.firstName, loggedIn?.surname || loggedIn?.lastName].filter(Boolean).join(' ') ||
    loggedIn?.email ||
    '';

  // console.log("Prescription data", updateFormRef.current);
  // console.log("Patient update data", patientUpdateRef.current);

  const updatePatient = async ({ silent = false } = {}) => {
    try {
      const result = await axios.put(`${END_POINT}/customer/updateProfile/${patientId}`, { ...patientUpdateRef.current, updatedByName: signedInName }, {
        headers: {
          Authorization: getJwtToken(),
        },
      });
      // Clear the dirty marker so a following save does not re-send the same flags.
      patientUpdateRef.current = null;
      if (!silent) toast.success('Saved!!');

      // successfully added
    } catch (error) {
      toast.error(error?.response?.data || 'Something went wrong');
      // fail to add Patient
      toast.error('Failed to update');
    }
  };

  const handleCtrlS = (event) => {
    if (event.ctrlKey && event.key === 's') {
      console.log(updateFormRef.current, 'what is  is', formDataRef.current)
      event.preventDefault();
      if (updateFormRef.current?.length > 0 || patientUpdateRef.current !== null) {
        console.log("Prescription data", updateFormRef.current);
        console.log("Patient update data", patientUpdateRef.current);
        updateFormRef.current?.length > 0 && dispatch(addNewPrescription(updateFormRef.current));
        patientUpdateRef.current !== null && updatePatient();
      } else if (updateFormRef.current?.length <= 0 && patientUpdateRef.current == null) {
        toast.error('No changes to save', { position: toast.POSITION.TOP_RIGHT });
      }
    }
  };

  const handleCtrlSS = () => {
    // event.preventDefault();
    if (updateFormRef.current?.length > 0) {
      dispatch(addNewPrescription(updateFormRef.current));
      // Optimistically stamp lastUpdatedBy so the badge appears without a reload.
      const now = new Date();
      const savedDates = new Set((updateFormRef.current || []).map((p) => p?.Date).filter(Boolean));
      setFormData((prev) =>
        prev?.map((item) =>
          savedDates.has(item?.Date)
            ? { ...item, lastUpdatedBy: { name: signedInName, role: '', at: now } }
            : item
        )
      );
    }
    toast.success('Prescription Created');
  };

  const handleCtrlSSS = () => {
    if (updateFormRef.current?.length > 0) {
      dispatch(addNewPrescription(updateFormRef.current));
      // Optimistically stamp lastUpdatedBy so the badge appears without a reload.
      const now = new Date();
      const savedDates = new Set((updateFormRef.current || []).map((p) => p?.Date).filter(Boolean));
      setFormData((prev) =>
        prev?.map((item) =>
          savedDates.has(item?.Date)
            ? { ...item, lastUpdatedBy: { name: signedInName, role: '', at: now } }
            : item
        )
      );
    }
    toast.success('Prescription Saved');
  };

  useEffect(() => {
    return () => {
      setFormData(null);
      dispatch({ type: 'GET_ALL_PATIENT_PRESCRIPTION_DATA', payload: null });
      dispatch({ type: 'GET_SINGLE_PATIENT_SUCCESS', payload: null });
    };
  }, []);

  useEffect(() => {
    dispatch(getAllMedicines())
  }, [dispatch]);

  const [customData, setCustomData] = useState("");
  const [primary, setPrimary] = useState("")
  const [secondary, setSecondary] = useState("")
  const [tertiary, setTertiary] = useState("")
  const [primarySub, setPrimarySub] = useState("")
  const [secondarySub, setSecondarySub] = useState("")
  const [tertiarySub, setTertiarySub] = useState("")
  const [treatment, setTreatment] = useState("")
  const [visitStatus, setVisitStatus] = useState("")
  const [showPatientDetails, setShowPatientDetails] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      if (singlePatientData) {
        // simulate async (in case custom is processed/fetched)
        const custom = await Promise.resolve(singlePatientData.custom);
        const primary = await Promise.resolve(singlePatientData.diagnosis?.primary);
        const secondary = await Promise.resolve(singlePatientData.diagnosis?.secondary);
        const tertiary = await Promise.resolve(singlePatientData.diagnosis?.tertiary);
        const treatment = await Promise.resolve(singlePatientData?.status_by_treatment)
        setCustomData(custom || "");
        setPrimary(primary || "");
        setSecondary(secondary || "");
        setTertiary(tertiary || "");
        setPrimarySub(singlePatientData.diagnosis?.primarySub || "");
        setSecondarySub(singlePatientData.diagnosis?.secondarySub || "");
        setTertiarySub(singlePatientData.diagnosis?.tertiarySub || "");
        setTreatment(treatment || "");
        setVisitStatus(singlePatientData?.status_by_visit || singlePatientData?.PatientStatus || singlePatientData?.patientStatus || "");
      }
    };

    fetchData();
  }, [singlePatientData]);

  const handleCustomFieldPost = async () => {
    try {
      const res = await dispatch(
        postCustomFieldtoPatients({
          patientId,
          fieldName: 'custom',
          fieldValue: customData,
          primary,
          secondary,
          tertiary,
          primarySub,
          secondarySub,
          tertiarySub,
          treatment,
          visitStatus,
          updatedByName: signedInName,
        })
      ).unwrap();
      // Case Study / Review / rating live on the patient record, so they ride along
      // with this save instead of needing their own button.
      if (patientUpdateRef.current !== null) await updatePatient({ silent: true });
      dispatch(getSinglePatientFetch(patientId));
      toast.success('Saved!!');
    } catch (error) {
      toast.error(typeof error === 'string' ? error : 'Failed to save');
    }
  };

  // Only mark the patient dirty once the doctor actually changes one of these,
  // otherwise every Ctrl+S would re-send the values we just read back.
  const handlePatientFlagChange = (name, value) => {
    setPatientUpdate((prev) => {
      const next = { ...(prev || {}), [name]: value };
      patientUpdateRef.current = next;
      return next;
    });
  };

  useEffect(() => {
    let query = { patient: patientId, doctor: userLogindata?.data?._id, ...paginate };
    dispatch(getAllPatientPrescription(query));
  }, [visibleDate, userLogindata, paginate]);

  useEffect(() => {
    if (getAllPrescriptionData?.length > 0) {
      setFormData(getAllPrescriptionData.map((item) => (item?.ReceivedBy ? item : { ...item, ReceivedBy: signedInName })));
    }
    // Deliberately not keyed on signedInName: the fetch above already re-runs once
    // the session hydrates, and re-running here would discard unsaved edits.
  }, [getAllPrescriptionData]);

  useEffect(() => {
    dispatch(getSinglePatientFetch(patientId));
    document.addEventListener('keydown', handleCtrlS);
    return () => {
      document.removeEventListener('keydown', handleCtrlS);
    };
  }, []);

  useEffect(() => {
    const { CaseRating, CaseMark, ReviewMark, BeforeAfterMark } = singlePatientData || {};
    setPatientUpdate({ CaseRating: CaseRating, CaseMark: CaseMark, ReviewMark: ReviewMark, BeforeAfterMark: BeforeAfterMark });
  }, [singlePatientData]);

  useEffect(() => {
    formDataRef.current[0] = formData;
  }, [formData]);

  // Records one edited field against the prescription it belongs to, keyed by Date.
  // Each prescription gets its own pending entry and repeated edits merge into it,
  // so editing two prescriptions before saving no longer loses one of them.
  const trackFieldChange = (ukey, name, value) => {
    const itemId = formData?.find((item) => item?.Date === ukey);
    if (!itemId) return;

    const pending = (updateFormRef.current || []).filter(Boolean);
    const existing = pending.find((item) => item?.Date === ukey);

    if (existing) {
      existing[name] = value;
      if (itemId?._id) existing._id = itemId._id;
      // Keep updatedByName current so a late edit still reflects the right user.
      existing.updatedByName = signedInName;
    } else {
      pending.push({
        Date: itemId?.Date,
        // Carry the defaulted "Received By" along, so saving any field on this
        // prescription also writes the name shown in the box.
        ...(itemId?.ReceivedBy && { ReceivedBy: itemId.ReceivedBy }),
        [name]: value,
        ...(itemId?._id && { _id: itemId._id }),
        customerId: singlePatientData?._id,
        paitendId: singlePatientData?.customerId,
        doctorId: userLogindata?.data?._id,
        patient: singlePatientData?._id,
        doctor: userLogindata?.data?._id,
        updatedByName: signedInName,
      });
    }

    updateFormRef.current = pending;
  };

  const handleTableChange = (e, ivalue, duration = null) => {
    const { id: ukey, name } = e.target || {};

    setFormData((prev) => prev?.map((item) => (item?.Date === ukey ? { ...item, [name]: ivalue } : item)));
    trackFieldChange(ukey, name, ivalue);
  };


  const handelInputChange = (event) => {
    const { name, value, id: ukey } = event?.target;

    setFormData((prev) => prev?.map((item) => (item?.Date === ukey ? { ...item, [name]: value } : item)));
    trackFieldChange(ukey, name, value);
  };

  //   const handelPriceTable = (event) => {
  //     let { name, value, id: ukey } = event.target;
  //     console.log(name,value)

  //     // Update the updateForm state
  //     let updatedForm = updateFormRef.current;
  //     const itemId = formData.find((item) => item.Date === ukey);

  //     // Update the formData state
  //     setFormData((prev) => prev?.map((item) => (item?.Date === ukey ? { ...item, PaymentDetails: { ...item?.PaymentDetails, [name]: value } } : item)));

  //     if (itemId?._id) {
  //       let updatedFormCopy = updatedForm?.length == 0 && updatedForm.push({ Date: itemId?.Date, PaymentDetails: { ...itemId?.PaymentDetails, [name]: value }, _id: itemId?._id, customerId: singlePatientData?._id, paitendId: singlePatientData?.customerId, doctorId: userLogindata?.data?._id });
  //       updatedFormCopy = updatedForm.map((item) => item.Date === ukey && { ...item, PaymentDetails: { ...itemId?.PaymentDetails, [name]: value }, _id: itemId?._id });
  //       updateFormRef.current = updatedFormCopy;
  //     } else {
  //       let NewFormCopy = updatedForm?.length == 0 && updatedForm.push({ Date: itemId?.Date, PaymentDetails: { [name]: value }, customerId: singlePatientData?._id, paitendId: singlePatientData?.customerId, doctorId: userLogindata?.data?._id });
  //       NewFormCopy = updatedForm.map((item) => item.Date === ukey && { ...item, PaymentDetails: { [name]: value } });
  //       updateFormRef.current = NewFormCopy;
  //     }

  // const totalRef = updateFormRef.current.find((item) => item.Date === ukey);

  // // Separate total and paid
  // let total = 0;
  // let paid = 0;

  // Object.entries(totalRef?.PaymentDetails || {}).forEach(([key, val]) => {
  //   let num = Number(val) || 0;
  //   if (key === "paid") {
  //     paid = num;
  //   } else {
  //     total += num;
  //   }
  // });

  // // Remaining is total - paid
  // let remaining = total - paid;

  // // Update formData
  // setFormData((prev) =>
  //   prev?.map((item) =>
  //     item?.Date === ukey
  //       ? { ...item, total, paid, remaining }
  //       : item
  //   )
  // );

  // updatedForm = updatedForm.map((item) =>
  //   item.Date === ukey ? { ...item, total, paid, remaining } : item
  // );

  // updateFormRef.current = updatedForm; 

  // console.log("Updated PaymentDetails", updatedForm);

  //   };

  const calculateTotals = (paymentDetails = {}) => {
    let total = 0;
    let paid = 0;

    Object.entries(paymentDetails).forEach(([key, val]) => {
      // Row names (package / therapy picked from a dropdown) are not amounts.
      if (key.endsWith("_label")) return;
      const num = Number(val) || 0;
      if (key === "paid") {
        paid = num;
      } else {
        total += num;
      }
    });

    const remaining = total - paid;
    return { total, paid, remaining };
  };

  // Always asks the server for the newest prescription, since the loaded page may not include it.
  const getLastPrescriptionRemaining = async () => {
    try {
      const { data } = await axios.get(`${END_POINT}/prescription?patientId=${patientId}&doctorId=${userLogindata?.data?._id}&page=1&pageSize=1`, {
        headers: { Authorization: getJwtToken() },
      });
      const last = Array.isArray(data) ? data[0] : null;
      return last ? calculateTotals(last.PaymentDetails).remaining : 0;
    } catch (error) {
      const last = [...(formData || [])].filter((item) => item?._id).sort((a, b) => getSafeTime(b?.Date) - getSafeTime(a?.Date))[0];
      return last ? calculateTotals(last.PaymentDetails).remaining : 0;
    }
  };

  const handelPriceTable = (event) => {
    let { name, value, id: ukey } = event.target;
    console.log(name, value);

    let updatedForm = updateFormRef.current;
    const itemId = formData.find((item) => item.Date === ukey);

    // Update the formData state
    setFormData((prev) =>
      prev?.map((item) =>
        item?.Date === ukey
          ? { ...item, PaymentDetails: { ...item?.PaymentDetails, [name]: value } }
          : item
      )
    );

    // Update the updateFormRef
    if (itemId?._id) {
      // Existing record
      const existingIndex = updatedForm.findIndex((item) => item.Date === ukey);
      if (existingIndex !== -1) {
        updatedForm[existingIndex] = {
          ...updatedForm[existingIndex],
          PaymentDetails: { ...updatedForm[existingIndex].PaymentDetails, [name]: value },
        };
      } else {
        updatedForm.push({
          Date: itemId.Date,
          PaymentDetails: { ...itemId.PaymentDetails, [name]: value },
          _id: itemId._id,
          customerId: singlePatientData?._id,
          paitendId: singlePatientData?.customerId,
          doctorId: userLogindata?.data?._id,
          patient: singlePatientData?._id,
          doctor: userLogindata?.data?._id,
        });
      }
    } else {
      // New record
      const existingIndex = updatedForm.findIndex((item) => item.Date === ukey);
      if (existingIndex !== -1) {
        updatedForm[existingIndex] = {
          ...updatedForm[existingIndex],
          PaymentDetails: { ...updatedForm[existingIndex].PaymentDetails, [name]: value },
        };
      } else {
        updatedForm.push({
          Date: itemId.Date,
          PaymentDetails: { ...itemId.PaymentDetails, [name]: value },
          customerId: singlePatientData?._id,
          paitendId: singlePatientData?.customerId,
          doctorId: userLogindata?.data?._id,
          patient: singlePatientData?._id,
          doctor: userLogindata?.data?._id,
        });
      }
    }

    // Calculate total, paid, remaining
    const totalRef = updatedForm.find((item) => item.Date === ukey);
    const { total, paid, remaining } = calculateTotals(totalRef?.PaymentDetails);

    // Update formData totals
    setFormData((prev) =>
      prev?.map((item) =>
        item?.Date === ukey
          ? { ...item, total, paid, remaining }
          : item
      )
    );

    // Update updatedForm with totals
    updatedForm = updatedForm.map((item) =>
      item.Date === ukey ? { ...item, total, paid, remaining } : item
    );

    updateFormRef.current = updatedForm;

    console.log("Updated PaymentDetails", updatedForm);
  };

  useEffect(() => {
    if (formData?.length) {
      // Only recalc if totals are missing or wrong
      const updated = formData.map((item) => {
        const { total, paid, remaining } = calculateTotals(item.PaymentDetails);

        // ✅ Prevent infinite re-render by only updating if values differ
        if (
          item.total !== total ||
          item.paid !== paid ||
          item.remaining !== remaining
        ) {
          return { ...item, total, paid, remaining };
        }
        return item; // unchanged
      });

      // Only update state if something actually changed
      const isChanged = updated.some(
        (item, idx) =>
          item.total !== formData[idx].total ||
          item.paid !== formData[idx].paid ||
          item.remaining !== formData[idx].remaining
      );

      if (isChanged) {
        setFormData(updated);
        updateFormRef.current = updated;
      }
    }
  }, [formData]); // safe now



  useEffect(() => {
    if (updatePrescriptionSuccess && !updatePrescriptionProcessing) {
      toast.success(updatePrescriptionMessage, { position: toast.POSITION.TOP_RIGHT });

      //  reset states
      // window.location.reload();
      setFormError([initialFormData]);
    }
    if (updatePrescriptionFail && !updatePrescriptionProcessing) {
      toast.error(updatePrescriptionMessage, { position: toast.POSITION.TOP_RIGHT });
    }
  }, [updatePrescriptionProcessing]);

  const sortedFormData = () => [...(formData || [])].sort((a, b) => getSafeTime(b?.Date) - getSafeTime(a?.Date));

  const openPrintPreview = () => {
    const sorted = sortedFormData();
    if (sorted.length === 0) {
      toast.error('No prescription entries to print');
      return;
    }
    const defaultEntry = sorted.find((e) => e.Date === visibleDate) || sorted[0];
    setPrintDate(defaultEntry.Date);
    setShowPrintPreview(true);
  };

  // Captures the hidden, purpose-built PrescriptionPrintTemplate (not the live
  // edit form) into a clean, multi-page PDF for the single selected visit date.
  // Uses intelligent whitespace detection to break pages cleanly between lines
  // or sections without ever slicing text horizontally.
  const generatePrescriptionPDF = (entryForPdf) => {
    const input = printTemplateRef.current;
    if (!input) return;

    html2canvas(input, { scale: 2, useCORS: true, backgroundColor: "#ffffff" }).then((canvas) => {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Every page gets the same printable box, preserving margins across all pages
      const contentWidth = pageWidth - PDF_MARGIN_MM * 2;
      const contentHeight = pageHeight - PDF_MARGIN_MM * 2;

      const pxPerMm = canvas.width / contentWidth;
      const maxSliceHeightPx = Math.floor(contentHeight * pxPerMm);

      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imgData.data;
      const width = canvas.width;
      const height = canvas.height;

      // Checks whether a given row in the canvas is pure whitespace (free of text/dark lines)
      const isBlankRow = (y) => {
        if (y < 0 || y >= height) return true;
        const rowOffset = y * width * 4;
        const startX = Math.floor(width * 0.04);
        const endX = Math.floor(width * 0.96);

        for (let x = startX; x < endX; x += 2) {
          const idx = rowOffset + x * 4;
          const a = data[idx + 3];
          if (a > 50) {
            const lum = 0.299 * data[idx] + 0.587 * data[idx + 1] + 0.114 * data[idx + 2];
            // Dark text / stroke threshold
            if (lum < 175) {
              return false;
            }
          }
        }
        return true;
      };

      let renderedPx = 0;
      let pageIndex = 0;

      while (renderedPx < height) {
        const remainingPx = height - renderedPx;

        // If the remaining content fits within a single page, render it completely
        if (remainingPx <= maxSliceHeightPx) {
          const strip = document.createElement("canvas");
          strip.width = width;
          strip.height = remainingPx;

          const stripCtx = strip.getContext("2d");
          stripCtx.fillStyle = "#ffffff";
          stripCtx.fillRect(0, 0, strip.width, remainingPx);
          stripCtx.drawImage(canvas, 0, renderedPx, width, remainingPx, 0, 0, width, remainingPx);

          if (pageIndex > 0) pdf.addPage();
          pdf.addImage(
            strip.toDataURL("image/png"),
            "PNG",
            PDF_MARGIN_MM,
            PDF_MARGIN_MM,
            contentWidth,
            remainingPx / pxPerMm
          );
          break;
        }

        // Multi-page: find a clean cut line in the whitespace between text lines
        const targetY = renderedPx + maxSliceHeightPx;
        const maxLookback = Math.floor(maxSliceHeightPx * 0.28);
        const minY = Math.max(renderedPx + Math.floor(maxSliceHeightPx * 0.5), targetY - maxLookback);

        // Find contiguous blank gaps in [minY, targetY]
        const gaps = [];
        let inGap = false;
        let gapEnd = -1;

        for (let y = targetY; y >= minY; y--) {
          const blank = isBlankRow(y);
          if (blank && !inGap) {
            inGap = true;
            gapEnd = y;
          } else if (!blank && inGap) {
            inGap = false;
            const gapStart = y + 1;
            const size = gapEnd - gapStart + 1;
            if (size >= 3) {
              gaps.push({ start: gapStart, end: gapEnd, size, center: Math.floor((gapStart + gapEnd) / 2) });
            }
          }
        }
        if (inGap) {
          const size = gapEnd - minY + 1;
          if (size >= 3) {
            gaps.push({ start: minY, end: gapEnd, size, center: Math.floor((minY + gapEnd) / 2) });
          }
        }

        let cutY = targetY;
        let nextRenderedPx = targetY;

        if (gaps.length > 0) {
          let bestGap = gaps[0];
          let bestScore = -Infinity;

          for (const g of gaps) {
            const dist = targetY - g.center;
            // Larger gaps (between sections or paragraphs) get preference, balanced with page fullness
            const sizeBonus = Math.min(g.size, 40) * 12;
            const distPenalty = (dist / maxLookback) * 140;
            const score = sizeBonus - distPenalty;
            if (score > bestScore) {
              bestScore = score;
              bestGap = g;
            }
          }

          cutY = bestGap.center;
          nextRenderedPx = bestGap.end + 1;
        }

        const stripHeight = cutY - renderedPx;
        const strip = document.createElement("canvas");
        strip.width = width;
        strip.height = stripHeight;

        const stripCtx = strip.getContext("2d");
        stripCtx.fillStyle = "#ffffff";
        stripCtx.fillRect(0, 0, strip.width, stripHeight);
        stripCtx.drawImage(canvas, 0, renderedPx, width, stripHeight, 0, 0, width, stripHeight);

        if (pageIndex > 0) pdf.addPage();
        pdf.addImage(
          strip.toDataURL("image/png"),
          "PNG",
          PDF_MARGIN_MM,
          PDF_MARGIN_MM,
          contentWidth,
          stripHeight / pxPerMm
        );

        renderedPx = nextRenderedPx;
        pageIndex += 1;
      }

      const patientName = [singlePatientData?.firstName, singlePatientData?.surname].filter(Boolean).join('_') || 'Patient';
      const dateLabel = entryForPdf?.Date || 'prescription';
      pdf.save(`Prescription_${patientName}_${dateLabel}.pdf`);
    });
  };

  const handleSaveAndPrint = () => {
    const entry = formData?.find((e) => e.Date === printDate);
    handleCtrlSSS();
    generatePrescriptionPDF(entry);
    setShowPrintPreview(false);
  };

  const [dropdownData, setDropdownData] = useState([])

  useEffect(() => {
    dispatch(getAllDropDowns())
  }, []);

  const fetchMainServices = async () => {
    try {
      const res = await axios.get(`${BaseUrl}subAilments/main-services`);
      // if(selectedValues?.main_service){
      //   let selecteddata = res?.data?.data?.filter(d=>d?.main_service===selectedValues?.main_service)?.[0]
      //   setSelectedValues(selecteddata)
      // }
      setDropdownData(res.data.data);
    } catch (error) {
      console.error('Error fetching main services:', error);
    }
  };

  useEffect(() => {
    fetchMainServices();
  }, []);

  const mainCategories = useMemo(() => dropdownData.map(item => item.main_service), [dropdownData]);


  const { primary_diagnosis, secondary_diagnosis, tertiary_diagnosis, primary_sub_diagnosis, secondary_sub_diagnosis, tertiary_sub_diagnosis, status_by_treatment, status_by_appointment } = useSelector((state) => state?.dropDown?.getallDropDowns?.[0] || {})

  // Main -> sub diagnosis pairs from the DropDowns page. A diagnosis with no
  // subs of its own keeps offering the flat sub list, so nothing goes blank.
  const { parents: diagnosisParents, childrenOf: subDiagnosisOf } = useLinkedDropdown('diagnosis');

  const diagnosisOptions = useMemo(() => {
    const base = diagnosisParents.length ? diagnosisParents : mainCategories;
    return [...new Set([...base, primary, secondary, tertiary].filter(Boolean))];
  }, [diagnosisParents, mainCategories, primary, secondary, tertiary]);

  const subOptionsFor = useCallback(
    (parent, fallback, current) => {
      const { options } = resolveChildSelection(subDiagnosisOf(parent), fallback || [], current);
      return [...new Set([...options, current].filter(Boolean))];
    },
    [subDiagnosisOf]
  );

  const primarySubOptions = useMemo(
    () => subOptionsFor(primary, primary_sub_diagnosis, primarySub),
    [subOptionsFor, primary, primary_sub_diagnosis, primarySub]
  );
  const secondarySubOptions = useMemo(
    () => subOptionsFor(secondary, secondary_sub_diagnosis, secondarySub),
    [subOptionsFor, secondary, secondary_sub_diagnosis, secondarySub]
  );
  const tertiarySubOptions = useMemo(
    () => subOptionsFor(tertiary, tertiary_sub_diagnosis, tertiarySub),
    [subOptionsFor, tertiary, tertiary_sub_diagnosis, tertiarySub]
  );

  // Choosing a diagnosis pulls its sub along: one sub is picked outright, and a
  // sub left over from the previous diagnosis is dropped.
  const handlePrimaryChange = (value) => {
    setPrimary(value);
    setPrimarySub(resolveChildSelection(subDiagnosisOf(value), primary_sub_diagnosis, primarySub).value);
  };
  const handleSecondaryChange = (value) => {
    setSecondary(value);
    setSecondarySub(resolveChildSelection(subDiagnosisOf(value), secondary_sub_diagnosis, secondarySub).value);
  };
  const handleTertiaryChange = (value) => {
    setTertiary(value);
    setTertiarySub(resolveChildSelection(subDiagnosisOf(value), tertiary_sub_diagnosis, tertiarySub).value);
  };

  // The lists configured on the DropDowns page, the same ones the graphs count
  // against, so a status picked here never lands in a graph's "Other". The
  // canonical lists only stand in while nothing is configured, and the
  // patient's current value is kept so an old status still shows.
  const treatmentOptions = useMemo(
    () => [...new Set([...(status_by_treatment?.length ? status_by_treatment : treatmentStatusOptions), treatment].filter(Boolean))],
    [status_by_treatment, treatment]
  );
  const visitOptions = useMemo(
    () => [...new Set([...(status_by_appointment?.length ? status_by_appointment : visitStatusOptions), visitStatus].filter(Boolean))],
    [status_by_appointment, visitStatus]
  );

  // Same figure the Modify Patient screen shows, so the doctor can see at a glance
  // how much of the record is still blank without leaving the prescription.
  const completion = getProfileCompletion(singlePatientData);

  const lastUpdatedBy = singlePatientData?.lastUpdatedBy;
  const lastUpdatedText = lastUpdatedBy?.at && !isNaN(new Date(lastUpdatedBy.at).getTime())
    ? format(new Date(lastUpdatedBy.at), 'dd/MM/yyyy hh:mm a')
    : 'Not recorded yet';

  const lastClinicVisit = useMemo(() => {
    const dates = (getAllPrescriptionData || []).map((item) => item?.Date).filter(Boolean);
    if (!dates.length) return '';
    const latest = dates.reduce((a, b) => (new Date(a) > new Date(b) ? a : b));
    const parsed = new Date(latest);
    return isNaN(parsed.getTime()) ? '' : format(parsed, 'dd/MM/yyyy');
  }, [getAllPrescriptionData]);

  // Read-only snapshot of the patient record; all of it is edited on Modify Patient.
  const patientSummary = [
    ['Age Group', singlePatientData?.ageGroup || deriveAgeGroup(singlePatientData?.dateOfBirth)],
    ['Blood Group', singlePatientData?.bloodGroup],
    ['Gender', singlePatientData?.gender],
    ['Marital Status', singlePatientData?.maritalStatus],
    ['Mother Tongue', singlePatientData?.motherTongue],
    ['Education', singlePatientData?.education],
    ['Location', singlePatientData?.location],
    ['State', singlePatientData?.state],
    ['Patient Reference', singlePatientData?.patientReference || singlePatientData?.patient_reference],
    ['Industry', singlePatientData?.industry],
    ['Profession', singlePatientData?.profession],
    ['Type of Patient', singlePatientData?.Patient_Type],
    ['Last Clinic Visit Date', lastClinicVisit],
  ];

  return (
    <div className="rounded-md h-fit lg:px-6 w-full px-5 p-3">

      {/* Modern Header & Patient Info Card */}
      <div className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 mb-4">
        {/* Top row: Back button, Patient identity, Patient summary chips, and Action buttons */}
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
          {/* Left: Back button & Patient identifier */}
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 hover:border-slate-300 bg-white hover:bg-slate-50 text-slate-700 text-xs font-semibold shadow-sm transition active:scale-[0.98]"
              title="Go back"
            >
              <FiArrowLeft className="w-4 h-4" />
              <span>Back</span>
            </button>

            <button
              onClick={() => {
                dispatch(getSinglePatient(singlePatientData));
                navigate(`/Patients/${singlePatientData?._id}`);
              }}
              className="flex items-center gap-2.5 px-3 py-1.5 rounded-xl border border-slate-100 hover:border-slate-200 hover:bg-slate-50/80 transition text-left group"
              title="View patient profile"
            >
              <div className="w-8 h-8 rounded-full bg-sky-100 text-sky-700 flex items-center justify-center font-bold text-xs shrink-0">
                {(singlePatientData?.firstName?.charAt(0) || 'P').toUpperCase()}
              </div>
              <div>
                <h3 className="font-bold text-sm text-slate-900 group-hover:text-sky-600 transition leading-tight">
                  {singlePatientData?.firstName
                    ? `${singlePatientData.firstName.charAt(0).toUpperCase() + singlePatientData.firstName.slice(1)} ${singlePatientData?.surname ? singlePatientData.surname.charAt(0).toUpperCase() + singlePatientData.surname.slice(1) : ''}`
                    : 'Patient Name'}
                </h3>
                <span className="inline-block text-[11px] font-medium text-slate-500">
                  ID: <span className="font-semibold text-slate-700">{singlePatientData?.customerId || 'N/A'}</span>
                </span>
              </div>
            </button>
          </div>

          {/* Right: Actions Toolbar */}
          <div className="flex flex-wrap items-center gap-2">
            <div className="flex items-center gap-1.5 bg-slate-50 border border-slate-200 rounded-xl px-2.5 py-1.5 shadow-sm">
              <FiCalendar className="w-3.5 h-3.5 text-slate-400" />
              <input
                onChange={(e) => {
                  setVisibleDate(e.target.value);
                }}
                type="date"
                name=""
                id=""
                value={visibleDate}
                className="bg-transparent text-xs font-medium text-slate-700 outline-none cursor-pointer"
              />
            </div>

            <button
              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-sky-600 hover:bg-sky-700 text-white rounded-xl font-semibold text-xs shadow-sm shadow-sky-600/20 transition active:scale-[0.98]"
              onClick={async (e) => {
                e.preventDefault();

                if (formData?.some((e) => e.Date === visibleDate)) {
                  handleCtrlSS();
                  return;
                }

                const previousBalance = await getLastPrescriptionRemaining();
                const newPrescription = {
                  ...initialFormData,
                  customerId: singlePatientData?._id,
                  paitendId: singlePatientData?.customerId,
                  doctorId: userLogindata?.data?._id,
                  patient: singlePatientData?._id,
                  doctor: userLogindata?.data?._id,
                  Date: visibleDate,
                  ReceivedBy: signedInName,
                  updatedByName: signedInName,
                  PaymentDetails: previousBalance ? { previous_balance_deposits: previousBalance } : {},
                };

                setFormData((prev) => (prev == null ? [newPrescription] : [newPrescription, ...prev]));

                handleCtrlSS();
              }}
            >
              <FiPlus className="w-3.5 h-3.5" />
              <span>Add New</span>
            </button>

            <button
              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-semibold text-xs shadow-sm shadow-emerald-600/20 transition active:scale-[0.98]"
              onClick={handleCustomFieldPost}
              title="Save Diagnosis & Treatment Fields"
            >
              <FiSave className="w-3.5 h-3.5" />
              <span>Save</span>
            </button>

            <button
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl border border-slate-200 hover:border-slate-300 bg-white hover:bg-slate-50 text-slate-700 text-xs font-semibold shadow-sm transition active:scale-[0.98]"
              onClick={openPrintPreview}
              title="Preview & Download Prescription"
            >
              <FiDownload className="w-3.5 h-3.5" />
              <span>Download</span>
            </button>
          </div>
        </div>

        {/* Completion of the Modify Patient record + who last touched it */}
        <div className="mt-3 pt-3 border-t border-slate-100 flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-6">
          <div className="flex items-center gap-2">
            <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">Profile</span>
            <CompletionRing percent={completion.percent} />
            <button
              onClick={() => navigate(`/patients/${patientId}`)}
              className="ml-1 px-2 py-0.5 rounded-lg border border-slate-200 hover:border-sky-300 hover:bg-sky-50 text-[11px] font-semibold text-slate-600 hover:text-sky-700 transition"
              title={completion.missing?.length ? `Missing: ${completion.missing.join(', ')}` : 'All fields filled'}
            >
              Modify
            </button>
            <button
              onClick={() => setShowPatientDetails((prev) => !prev)}
              className="ml-1 inline-flex items-center gap-1 px-2 py-0.5 rounded-lg border border-slate-200 hover:border-slate-300 hover:bg-slate-50 text-[11px] font-semibold text-slate-600 transition"
              title={showPatientDetails ? 'Hide patient details' : 'Show patient details'}
            >
              <span>{showPatientDetails ? 'Hide' : 'Details'}</span>
              <FiChevronDown className={`w-3.5 h-3.5 transition-transform ${showPatientDetails ? 'rotate-180' : ''}`} />
            </button>
          </div>

         
        </div>

        {showPatientDetails && (
          <>
          {/* Patient record snapshot — read-only here, edited on Modify Patient */}
          <div className="mt-3 pt-3 border-t border-slate-100 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-2">
            {patientSummary.map(([label, value]) => (
              <div key={label} className="bg-slate-50/80 border border-slate-100 rounded-xl px-2.5 py-1.5">
                <span className="block text-[10px] font-semibold text-slate-400 uppercase tracking-wider truncate" title={label}>
                  {label}
                </span>
                <span className="block text-xs font-medium text-slate-700 truncate" title={value || '-'}>
                  {value || '-'}
                </span>
              </div>
            ))}
          </div>

          {/* Bottom row: Diagnosis & Treatment Inputs */}
          <div className="mt-3 pt-3 border-t border-slate-100 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
            <div>
              <CustomSelectForPrescrption
                label="Status As Per Treatment"
                options={treatmentOptions}
                onChange={(e) => {
                  setTreatment(e.target.value);
                }}
                value={treatment}
                placeholder={"Choose Status"}
              />
            </div>

            <div>
              <label className="block mb-1 text-xs font-semibold text-slate-600">Custom</label>
              <input
                className="w-full rounded-xl border border-slate-200 hover:border-slate-300 bg-white px-3 py-1.5 text-xs font-medium text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 transition shadow-sm"
                type="text"
                placeholder="Enter Custom"
                value={customData || ""}
                onChange={(e) => setCustomData(e.target.value)}
              />
            </div>

            <div>
              <SearchableSelect
                label="Primary"
                disabled={''}
                options={diagnosisOptions}
                onChange={(e) => {
                  handlePrimaryChange(e.target.value);
                }}
                value={primary}
                placeholder={"Search Primary"}
                size="sm"
              />
            </div>

            <div>
              <SearchableSelect
                label="Secondary"
                options={diagnosisOptions}
                onChange={(e) => {
                  handleSecondaryChange(e.target.value);
                }}
                value={secondary || ""}
                placeholder={`Search Secondary`}
                size="sm"
              />
            </div>

            <div>
              <SearchableSelect
                label="Tertiary"
                options={diagnosisOptions}
                onChange={(e) => {
                  handleTertiaryChange(e.target.value);
                }}
                value={tertiary}
                placeholder={`Search Tertiary`}
                size="sm"
              />
            </div>

            <div>
              <SearchableSelect
                label="Primary Sub Diagnosis"
                options={primarySubOptions}
                onChange={(e) => {
                  setPrimarySub(e.target.value);
                }}
                value={primarySub}
                placeholder={`Search Primary Sub`}
                size="sm"
              />
            </div>

            <div>
              <SearchableSelect
                label="Secondary Sub Diagnosis"
                options={secondarySubOptions}
                onChange={(e) => {
                  setSecondarySub(e.target.value);
                }}
                value={secondarySub}
                placeholder={`Search Secondary Sub`}
                size="sm"
              />
            </div>

            <div>
              <SearchableSelect
                label="Tertiary Sub Diagnosis"
                options={tertiarySubOptions}
                onChange={(e) => {
                  setTertiarySub(e.target.value);
                }}
                value={tertiarySub}
                placeholder={`Search Tertiary Sub`}
                size="sm"
              />
            </div>

            <div>
              <CustomSelectForPrescrption
                label="Status of Patient"
                options={visitOptions}
                onChange={(e) => {
                  setVisitStatus(e.target.value);
                }}
                value={visitStatus}
                placeholder={`Choose Patient Status`}
              />
            </div>
          </div>

          {/* Case flags on the patient record — persisted by the Save button above or Ctrl+S */}
          <div className="mt-3 pt-3 border-t border-slate-100 flex flex-wrap items-center gap-x-6 gap-y-3">
            <div className="flex items-center gap-2">
              <span className="text-xs font-semibold text-slate-600">Rate Case</span>
              <div className="flex items-center gap-0.5">
                {[...Array(5)].map((_, index) => (
                  <FaStar
                    key={index}
                    onClick={() => handlePatientFlagChange('CaseRating', index + 1)}
                    className={`cursor-pointer h-4 w-4 transition ${index < (patientUpdate?.CaseRating || 0) ? 'text-yellow-400' : 'text-slate-300 hover:text-yellow-200'}`}
                    title={`Rate this case ${index + 1} out of 5`}
                  />
                ))}
              </div>
            </div>

            <label htmlFor="CaseMark" className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                id="CaseMark"
                checked={!!patientUpdate?.CaseMark}
                onChange={(e) => handlePatientFlagChange('CaseMark', e.target.checked)}
                className="h-4 w-4 accent-sky-600 cursor-pointer"
              />
              <span className="text-xs font-semibold text-slate-600">Case Study</span>
            </label>

            <label htmlFor="ReviewMark" className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                id="ReviewMark"
                checked={!!patientUpdate?.ReviewMark}
                onChange={(e) => handlePatientFlagChange('ReviewMark', e.target.checked)}
                className="h-4 w-4 accent-sky-600 cursor-pointer"
              />
              <span className="text-xs font-semibold text-slate-600">Review</span>
            </label>

            <label htmlFor="BeforeAfterMark" className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                id="BeforeAfterMark"
                checked={!!patientUpdate?.BeforeAfterMark}
                onChange={(e) => handlePatientFlagChange('BeforeAfterMark', e.target.checked)}
                className="h-4 w-4 accent-sky-600 cursor-pointer"
              />
              <span className="text-xs font-semibold text-slate-600">After &amp; Before</span>
            </label>
          </div>
          </>
        )}
      </div>

      <div className="mainpaddLayout">
        <div className="form_controls mt-2 h-[120vh] overflow-y-scroll" ref={scrollContainerRef} style={{ overflowY: 'scroll', height: '100vh' }}>
          {formData === null ? (
            getAllPrescriptionData?.length !== 0 ? (
              <div className="text-center pt-[30vh]">
                <CustomSpinner />
              </div>
            ) : (
              <h1 className="text-2xl font-bold">No Records Available</h1>
            )
          ) : (
            formData
              .sort((a, b) => getSafeTime(b?.Date) - getSafeTime(a?.Date))
              ?.map((singlePrescriptionForm, index) => (
                <div
                  key={singlePrescriptionForm?._id || singlePrescriptionForm?.Date || index}
                  className="mb-8 pb-6 border-b-4 border-slate-200 last:border-b-0 last:mb-0"
                >
                  <div className="flex items-center gap-2 py-2 px-2 mb-1 flex-wrap">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-sky-50 border border-sky-200 text-sky-800 text-xs font-semibold shadow-xs">
                      <FiCalendar className="w-3.5 h-3.5 text-sky-600" />
                      Prescription Date: {safeFormatDate(singlePrescriptionForm?.Date)}
                    </span>
                  </div>

                  <PrescriptionForm disabled={false} handelPriceTable={handelPriceTable} formData={singlePrescriptionForm} setFormData={setFormData} handelInputChange={handelInputChange} prescriptionScrollDate={singlePrescriptionForm?.Date} handleTableChange={handleTableChange} handleCtrlS={handleCtrlSSS} />
                </div>
                // format(new Date(singlePrescriptionForm?.Date), 'dd/MM/yyyy') !== format(new Date(visibleDate), 'dd/MM/yyyy') ? true : false
              ))
          )}
        </div>
      </div>

      <PaginationButtons
        onPreviousClick={() => {
          scrollContainerRef.current.scrollTop = 0;
          setpaginate({ ...paginate, page: paginate.page - 1 });
        }}
        onNextClick={() => {
          scrollContainerRef.current.scrollTop = 0;
          setpaginate({ ...paginate, page: paginate.page + 1 });
        }}
        isPreviousDisabled={paginate.page === 1}
        isNextDisabled={getAllPrescriptionData?.length < paginate.limit}
      />

      {/* Preview & Print modal: reuses the same editable form (so any change made
          here saves back to the record), scoped to a single selected visit date. */}
      <Modal
        isOpen={showPrintPreview}
        onClose={() => setShowPrintPreview(false)}
        title="Preview Prescription"
        subtitle="Review or edit this visit's details, then print."
        maxWidth="max-w-[96vw]"
        footer={
          <>
            <button
              onClick={() => setShowPrintPreview(false)}
              className="px-4 py-2 rounded-xl text-xs font-semibold text-slate-600 border border-slate-200 hover:bg-slate-50 transition"
            >
              Cancel
            </button>
            <button
              onClick={handleSaveAndPrint}
              className="px-4 py-2 rounded-xl text-xs font-semibold text-white bg-sky-600 hover:bg-sky-700 shadow-sm shadow-sky-600/20 transition"
            >
              Save & Print
            </button>
          </>
        }
      >
        <div className="flex items-center gap-2 mb-3">
          <FiCalendar className="w-3.5 h-3.5 text-slate-400" />
          <label className="text-xs font-semibold text-slate-600">Visit Date:</label>
          <select
            value={printDate || ''}
            onChange={(e) => setPrintDate(e.target.value)}
            className="border border-slate-200 rounded-lg px-2 py-1 text-xs font-medium text-slate-700 outline-none"
          >
            {sortedFormData().map((entry) => (
              <option key={entry.Date} value={entry.Date}>
                {safeFormatDate(entry?.Date)}
              </option>
            ))}
          </select>
        </div>

        <div className="overflow-auto border border-slate-200 rounded-xl" style={{ maxHeight: '65vh' }}>
          {formData?.find((e) => e.Date === printDate) && (
            <PrescriptionForm
              disabled={false}
              handelPriceTable={handelPriceTable}
              formData={formData.find((e) => e.Date === printDate)}
              setFormData={setFormData}
              handelInputChange={handelInputChange}
              prescriptionScrollDate={printDate}
              handleTableChange={handleTableChange}
              handleCtrlS={handleCtrlSSS}
            />
          )}
        </div>
      </Modal>

      {/* Hidden, purpose-built printable template — rendered off-screen so
          html2canvas can capture a clean document instead of screenshotting
          the interactive edit form above. */}
      <div style={{ position: 'fixed', top: 0, left: '-10000px', zIndex: -1 }}>
        <div ref={printTemplateRef}>
          <PrescriptionPrintTemplate
            entry={formData?.find((e) => e.Date === printDate)}
            patient={singlePatientData}
            clinicProfile={clinicProfile}
            doctorName={userLogindata?.data?.name}
          />
        </div>
      </div>
    </div>
  );
};



const PrescriptionForm = ({ disabled, handelPriceTable, formData, setFormData, handelInputChange, handleTableChange, handleCtrlS }) => {
  const [showVitalSignsModal, setShowVitalSignsModal] = useState(false);
  const navigate = useNavigate();
  const { userLogindata } = useSelector((state) => state.AuthReducer);
  let { singlePatientData } = useSelector((state) => state.AdminReducer);
  // Mode of payment comes from the DropDowns page (the list the payment-mode
  // graphs count against); UPI / Cash only while nothing is configured. The
  // record's own value always stays selectable, spelt as it was saved, so a
  // renamed or deleted option does not silently blank an old prescription.
  const modeOfPayment = useSelector((state) => state?.dropDown?.getallDropDowns?.[0]?.mode_of_payment);
  const paymentModeOptions = useMemo(() => {
    const keyOf = (value) => String(value ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
    const configured = (Array.isArray(modeOfPayment) ? modeOfPayment : [])
      .map((item) => String(item ?? '').trim())
      .filter(Boolean);
    const base = configured.length ? configured : ['UPI', 'Cash'];
    const byKey = new Map();
    base.forEach((label) => {
      if (!byKey.has(keyOf(label))) byKey.set(keyOf(label), label);
    });
    const current = formData?.PaymentMode;
    if (current && String(current).trim()) byKey.set(keyOf(current), current);
    return [...byKey.values()];
  }, [modeOfPayment, formData?.PaymentMode]);

  // Payment Details Option 1 / Option 2 pick their names from the DropDowns
  // `package` and `alternative_treatment` lists.
  const { package: packageList, alternative_treatment: treatmentList } = useSelector(
    (state) => state?.dropDown?.getallDropDowns?.[0] || {}
  );

  const baseSymptomsRef = useRef('');

  const {
    interimText,
    listening: isListening,
    error: speechError,
    toggleListening: handleToggleSpeech,
  } = useSpeechToText({
    onAnythingSaid: (text) => {
      if (!text) return;
      const base = baseSymptomsRef.current;
      const display = base ? `${base} ${text}` : text;
      handelInputChange({
        target: {
          name: 'Symptoms',
          id: formData?.Date,
          value: display,
        },
      });
    },
    onFinalised: (text) => {
      if (!text) return;
      const base = baseSymptomsRef.current;
      const updated = base ? `${base} ${text.trim()}` : text.trim();
      baseSymptomsRef.current = updated;
      handelInputChange({
        target: {
          name: 'Symptoms',
          id: formData?.Date,
          value: updated,
        },
      });
    },
  });

  const toggleListening = async () => {
    if (speechError) {
      toast.error(speechError, { toastId: 'speech-recognition-error' });
      return;
    }
    try {
      if (!isListening) {
        if (navigator.mediaDevices?.getUserMedia) {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          stream.getTracks().forEach((track) => track.stop());
        }
        baseSymptomsRef.current = (formData?.Symptoms || '').trim();
        toast.dismiss('speech-recognition-status');
        toast.info('Listening... Speak now. Click the microphone again to stop.', {
          toastId: 'speech-recognition-status',
          autoClose: 3000,
        });
      } else {
        toast.dismiss('speech-recognition-status');
        toast.info('Speech recognition stopped', {
          toastId: 'speech-recognition-status',
          autoClose: 2000,
        });
      }
      handleToggleSpeech();
    } catch (error) {
      console.error('Error accessing microphone:', error);
      toast.error('Error accessing microphone. Please check your browser permissions.', {
        toastId: 'speech-recognition-error',
      });
    }
  };






  const handleAddMedicinePrescription = () => {
    const current = formData?.MedicinePrescription || { 0: { name: '', duration: '2 weeks' } };
    const keys = Object.keys(current).map(Number).filter((n) => !isNaN(n));
    const newIndex = keys.length ? Math.max(...keys) + 1 : Object.keys(current).length;
    const updated = {
      ...current,
      [newIndex]: { name: '', duration: '2 weeks', potency: '', intake: '' },
    };
    handleTableChange({ target: { id: formData?.Date, name: 'MedicinePrescription' } }, updated);
  };

  const handleAddSupplimentoryMedicine = () => {
    const current = formData?.SupplimentoryMedicine || { 0: { name: '', duration: '', fees: '' } };
    const keys = Object.keys(current).map(Number).filter((n) => !isNaN(n));
    const newIndex = keys.length ? Math.max(...keys) + 1 : Object.keys(current).length;
    const updated = {
      ...current,
      [newIndex]: { name: '', duration: '', intake: '', fees: '', quantity: '' },
    };
    handleTableChange({ target: { id: formData?.Date, name: 'SupplimentoryMedicine' } }, updated);
  };

  const handleAddPathologicalTest = () => {
    const current = formData?.PathologicalTests || { 0: { name: '', referredTo: '', amount: '', remarks: '' } };
    const keys = Object.keys(current).map(Number).filter((n) => !isNaN(n));
    const newIndex = keys.length ? Math.max(...keys) + 1 : Object.keys(current).length;
    const updated = {
      ...current,
      [newIndex]: { name: '', referredTo: '', amount: '', remarks: '' },
    };
    handleTableChange({ target: { id: formData?.Date, name: 'PathologicalTests' } }, updated);
  };

  // Courier fields ride in their own object rather than PaymentDetails, because the
  // payment table totals every value it finds there and the courier cost is recorded,
  // not billed.
  const handleCourierChange = (event) => {
    const { name, value } = event.target;
    handleTableChange(
      { target: { id: formData?.Date, name: 'CourierDetails' } },
      { ...(formData?.CourierDetails || {}), [name]: value },
    );
  };

  return (
    // Columns size to their own content and stack below xl, so a short viewport can no longer
    // push one visit's fields on top of the next card in the list.
    <div className="prescriptionFormLayout flex flex-col xl:flex-row items-stretch gap-4 xl:gap-0" id={formData?.Date} autoFocus={true} name={formData?.Date}>
      <div className="leftFromSection px-3 py-4 min-w-0 w-full xl:flex-none xl:w-[max(20vw,360px)]">
        <div className="border secondpartLeft p-2 rounded-lg">
          <CustomTextarea disabled={disabled} id={formData?.Date} label="Suggestions" placeholder="Enter Suggestions" onChange={handelInputChange} value={formData?.Suggestions} name="Suggestions" error={''} />
          <CustomTextarea disabled={disabled} id={formData?.Date} label="Reports Prescription" placeholder="Enter Report Prescription" onChange={handelInputChange} value={formData?.ReportsPrescription} name="ReportsPrescription" error={''} />
          <div className="mt-3">
            <MedicineTableCard
              title="Pathological Tests"
              disabled={disabled}
              onAdd={handleAddPathologicalTest}
              renderTable={() => <PathologicalTestTable disabled={disabled} PathologicalTests={formData?.PathologicalTests} formData={formData} handleTableChange={handleTableChange} />}
            />
            <LabReportUploads prescriptionId={formData?._id} patientId={singlePatientData?._id} />
          </div>
          <CustomTextarea disabled={disabled} id={formData?.Date} label="Probable Treatment" placeholder="Enter Probable Treatment" onChange={handelInputChange} value={formData?.ProbableTreatment} name="ProbableTreatment" error={''} />
          <CustomTextarea disabled={disabled} id={formData?.Date} label="Other" placeholder="Other" onChange={handelInputChange} value={formData?.Other} name="Other" error={''} />
        </div>
        <button
          className="w-full bg-sky-600 hover:bg-sky-700 text-white font-semibold py-2.5 px-4 rounded-xl text-xs shadow-sm shadow-sky-600/20 transition-all mt-3 active:scale-[0.99]"
          onClick={() => {
            navigate(`/appointment?patientId=${singlePatientData?._id || ''}`, {
              state: {
                patientId: singlePatientData?._id,
                patientData: singlePatientData,
                doctorData: userLogindata?.data,
              },
            });
          }}
        >
          Schedule Next Appointment
        </button>
        <div className="CourierTableDiv mt-4">
          <CourierTable disabled={disabled} handleCourierChange={handleCourierChange} formData={formData} />
        </div>
        <div className="PriceTableDiv mt-4">
          <PriceTable disabled={disabled} handelPriceTable={handelPriceTable} setFormData={setFormData} formData={formData} handleTableChange={handleTableChange} packageOptions={packageList} treatmentOptions={treatmentList} />
        </div>
        <div className="PayUp mt-4">
          <div className="inputWork">
            <div className="mt-5">
              <label className="text-sm font-medium text-slate-700 mb-1 block">Mode Of Payment</label>
              <select disabled={disabled} id={formData?.Date} value={formData?.PaymentMode || ''} name="PaymentMode" onChange={handelInputChange} className="w-full border border-slate-200 hover:border-slate-300 text-slate-800 text-xs font-medium rounded-xl focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 p-2.5 bg-white shadow-sm transition outline-none">
                <option value="" disabled>
                  Select Mode Of Payment
                </option>
                {paymentModeOptions.map((item, index) => (
                  <option key={index} value={item} className="text-slate-700">
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <CustomInput disabled={disabled} id={formData?.Date} onChange={handelInputChange} label="Received By" placeholder="Enter Name" type="text" value={formData?.ReceivedBy || ''} name="ReceivedBy" />
            {/* <CustomInput disabled={disabled} id={formData?.Date} onChange={handelInputChange} label="Amount Received" placeholder="Enter Amount" type="number" value={formData.paid} name="paid" /> */}
          </div>
        </div>
      </div>
      <hr className="hidden xl:block self-stretch w-[3px] h-auto border-0 bg-gray-300" />
      <div className="centerFromSection flex-1 min-w-0 px-5 py-4 flex flex-col">
        <div className="p-2 border rounded-lg flex-1 flex flex-col min-h-[420px]">
          <div className="flex flex-col relative flex-1 min-h-0">
            <div className="flex justify-between items-center mb-1">
              <label className="text-sm font-medium text-primary-900">Patient History</label>
              <button
                type="button"
                onClick={toggleListening}
                className={`p-2 rounded-full ${isListening ? 'bg-red-100 text-red-600' : 'bg-gray-100 text-gray-600'} hover:bg-gray-200 focus:outline-none`}
                title={isListening ? 'Stop dictation' : 'Start dictation'}
              >
                {isListening ? (
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 002 0V8a1 1 0 00-1-1zm4 0a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                ) : (
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z" clipRule="evenodd" />
                  </svg>
                )}
              </button>
            </div>

            <textarea
              disabled={disabled}
              id={formData?.Date}
              className="w-full border border-primary-300 text-primary-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 p-2.5 resize-vertical flex-1 min-h-[360px]"
              label="Symptoms"
              placeholder="Enter Patient History or click the microphone to dictate"
              onChange={handelInputChange}
              value={formData?.Symptoms || ''}
              name="Symptoms"
            />
            {isListening && (
              <div className="absolute right-3 top-10 flex items-center text-red-500 text-xs">
                <span className="animate-pulse mr-1">●</span> Listening...
              </div>
            )}
          </div>
        </div>
      </div>
      <hr className="hidden xl:block self-stretch w-[3px] h-auto border-0 bg-gray-300" />
      <div className="rightFromSection px-5 py-4 flex flex-col gap-5 min-w-0 w-full xl:flex-none xl:w-[380px]">
        <div className="PreviousReports border p-2 rounded rounded-lg">
          <ChildrenComponent disabled={disabled} id={formData?.Date} label="PREVIOUS REPORTS" handelInputChange={handelInputChange} formData={formData} setFormData={setFormData} uploadType="previousReports" SectionType="PreviousReportNotes" />
        </div>
        <div className="PreviousTreatment border p-2 rounded rounded-lg">
          <ChildrenComponent disabled={disabled} id={formData?.Date} label="PREVIOUS TREATMENT" handelInputChange={handelInputChange} formData={formData} setFormData={setFormData} uploadType="previousTreatment" SectionType="PreviousTreatmentNotes" />
        </div>
        <div className="PreviousPictures border p-2 rounded rounded-lg">
          <ChildrenComponent disabled={disabled} id={formData?.Date} label="PREVIOUS PICTURES" handelInputChange={handelInputChange} formData={formData} setFormData={setFormData} uploadType="pictures" SectionType="PreviousPicturesNotes" />
        </div>
        <MedicineTableCard
          title="Medicine Prescription"
          disabled={disabled}
          onAdd={handleAddMedicinePrescription}
          renderTable={() => (
            <MedicinePrescriptionTable disabled={disabled} MedicinePrescription={formData?.MedicinePrescription} setFormData={setFormData} formData={formData} handleTableChange={handleTableChange} />
          )}
        />
        <MedicineTableCard
          title="Supplimentory Medicine"
          disabled={disabled}
          onAdd={handleAddSupplimentoryMedicine}
          renderTable={() => (
            <SupplimentoryMedicineTable disabled={disabled} SupplimentoryMedicine={formData?.SupplimentoryMedicine} setFormData={setFormData} formData={formData} handleTableChange={handleTableChange} />
          )}
        />

        <div className="border border-slate-200 rounded-xl p-3 flex flex-col gap-2 bg-slate-50/50">
          <div className="grid grid-cols-3 gap-2">
            <button
              onClick={handleCtrlS}
              className="p-2 bg-sky-600 hover:bg-sky-700 transition-colors rounded-xl font-semibold text-white text-xs shadow-sm shadow-sky-600/20 active:scale-[0.98]"
            >
              Save
            </button>

            <button
              onClick={() => {
                if (!singlePatientData?._id) return toast.error('Patient not loaded yet');
                copyLink(`${window.location.origin}/public/patients/feedback/${singlePatientData._id}`);
              }}
              className="p-2 bg-sky-600 hover:bg-sky-700 transition-colors rounded-xl font-semibold text-white text-xs shadow-sm shadow-sky-600/20 active:scale-[0.98]"
            >
              Feedback
            </button>

            <button
              onClick={() => {
                if (!singlePatientData?._id) return toast.error('Patient not loaded yet');
                // An unsaved prescription has no id yet; the link still works for the patient.
                copyLink(`${window.location.origin}/public/patients/reports/${formData?._id || 'new'}/${singlePatientData._id}`);
              }}
              className="p-2 bg-sky-600 hover:bg-sky-700 transition-colors rounded-xl font-semibold text-white text-xs leading-tight shadow-sm shadow-sky-600/20 active:scale-[0.98]"
            >
              Upload Docs
            </button>
          </div>
          {userLogindata?.data.role === 'MainDoctor' && (
            <div className="grid grid-cols-3 gap-2">
              <button
                onClick={() => {
                  if (!singlePatientData?._id) return toast.error('Patient not loaded yet');
                  copyLink(`${window.location.origin}/public/diet/${singlePatientData._id}`);
                }}
                className="p-2 bg-sky-600 hover:bg-sky-700 transition-colors rounded-xl font-semibold text-white text-xs shadow-sm shadow-sky-600/20 active:scale-[0.98]"
              >
                Diet
              </button>

              <button
                onClick={() => {
                  if (!singlePatientData?._id) return toast.error('Patient not loaded yet');
                  setShowVitalSignsModal(true);
                }}
                className="p-2 bg-sky-600 hover:bg-sky-700 transition-colors rounded-xl font-semibold text-white text-xs shadow-sm shadow-sky-600/20 active:scale-[0.98]"
              >
                Vital Signs
              </button>

              <button
                onClick={() => {
                  if (!formData?._id) return toast.error('This prescription has not been saved yet');
                  if (!window.confirm('Are you sure you want to delete this prescription?')) return;
                  toast.loading('deleting...');
                  deletePrescription(formData._id);
                }}
                className="p-2 bg-rose-600 hover:bg-rose-700 transition-colors rounded-xl font-semibold text-white text-xs shadow-sm shadow-rose-600/20 active:scale-[0.98]"
              >
                Delete
              </button>

              {showVitalSignsModal && (
                <VitalSignsModal
                  isOpen={showVitalSignsModal}
                  onClose={() => setShowVitalSignsModal(false)}
                  patientId={singlePatientData?._id}
                  patientName={[singlePatientData?.firstName, singlePatientData?.surname].filter(Boolean).join(' ')}
                />
              )}
            </div>
          )}


          <br></br>


          {formData?.lastUpdatedBy?.name && (
            <div className="flex items-center gap-1.5 flex-wrap pt-1 text-xs text-slate-600">
              <FiFileText className="w-3.5 h-3.5 text-slate-400" />
              Last update by{' '}
              <span className="font-semibold text-slate-800">{formData.lastUpdatedBy.name}</span>
              {formData.lastUpdatedBy.role && (
                <span className="text-slate-400">({formData.lastUpdatedBy.role})</span>
              )}
              <span className="text-slate-400">·</span>
              <span className="font-medium text-slate-700">
                {formData.lastUpdatedBy.at && !isNaN(new Date(formData.lastUpdatedBy.at).getTime())
                  ? format(new Date(formData.lastUpdatedBy.at), 'dd/MM/yyyy hh:mm a')
                  : '—'}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const ChildrenComponent = ({ disabled, id, label, handelInputChange, formData, setFormData, uploadType, SectionType }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [showImage, setShowImages] = useState(false);

  const handleCloseModal = () => setIsModalOpen(false);
  const handleImageCloseModal = () => setShowImages(false);

  const handleFileUpload = async (file) => {
    if (file) {
      const res = await dispatch(UploadFile(file, formData?._id, uploadType, 'prescription'));
      const uploadedFileId = res?.data || res;

      setFormData((prev) => {
        if (!prev) return prev;
        if (Array.isArray(prev)) {
          return prev.map((item) =>
            item.Date === id || item._id === id || item._id === formData?._id
              ? { ...item, [uploadType]: uploadedFileId }
              : item
          );
        }
        return { ...prev, [uploadType]: uploadedFileId };
      });

      setIsModalOpen(false);
    }
  };

  const handleImageUpload = async (file) => {
    if (file) {
      const filesArray = Array.isArray(file) ? file : (file ? [file] : []);
      const targetId = formData?._id || id;
      const res = await dispatch(UploadImages(filesArray, targetId, uploadType, 'prescription'));

      const uploadedImageIds = Array.isArray(res)
        ? res
        : (Array.isArray(res?.data) ? res.data : (typeof res === 'string' && res !== 'uploaded' ? [res] : []));

      console.log(uploadedImageIds, "<--- uploadedImageIds");

      setFormData((prev) => {
        if (!prev) return prev;
        if (Array.isArray(prev)) {
          return prev.map((item) =>
            item.Date === id || item._id === id || item._id === targetId
              ? { ...item, [uploadType]: [...(item[uploadType] || []), ...uploadedImageIds] }
              : item
          );
        }
        return {
          ...prev,
          [uploadType]: [...(prev[uploadType] || []), ...uploadedImageIds]
        };
      });
      toast.success('Images uploaded');
      setIsModalOpen(false);
    }
  };

  const handleDelete = async () => {
    if (uploadType !== 'pictures') {
      await dispatch(RemoveFile(formData?.[uploadType], formData?._id, uploadType, 'prescription'));

      setFormData((prev) => {
        if (!prev) return prev;
        if (Array.isArray(prev)) {
          return prev.map((item) =>
            item.Date === id || item._id === id || item._id === formData?._id
              ? { ...item, [uploadType]: null }
              : item
          );
        }
        return { ...prev, [uploadType]: null };
      });
    } else {
      await dispatch(DeleteImages({ fileIds: formData?.[uploadType] }, formData?._id, 'prescription'));

      setFormData((prev) => {
        if (!prev) return prev;
        if (Array.isArray(prev)) {
          return prev.map((item) =>
            item.Date === id || item._id === id || item._id === formData?._id
              ? { ...item, [uploadType]: [] }
              : item
          );
        }
        return { ...prev, [uploadType]: [] };
      });
    }
  };

  return (
    <div className="ChildernMain flex flex-col gap-2">
      <h4 className="font-semibold">{label}</h4>
      <label className="text-xs p-0 m-0">
        {uploadType !== 'pictures'
          ? (formData?.[uploadType] ? '1 File' : 'No File Uploaded')
          : `${formData?.[uploadType]?.length || 0} image uploaded`}
      </label>

      <div className="pChilldrenControls flex items-center gap-2">
        <button
          disabled={disabled}
          className="rounded-lg border border-slate-200 hover:border-slate-300 bg-white hover:bg-slate-50 text-slate-700 px-3 py-1 text-xs font-semibold shadow-sm transition active:scale-[0.98] disabled:opacity-50"
          onClick={() => setIsModalOpen(uploadType)}
        >
          UPLOAD
        </button>

        <button
          disabled={disabled}
          className="rounded-lg border border-slate-200 hover:border-rose-200 bg-white hover:bg-rose-50 text-slate-700 hover:text-rose-600 px-3 py-1 text-xs font-semibold shadow-sm transition active:scale-[0.98] disabled:opacity-50"
          onClick={handleDelete}
        >
          DELETE
        </button>

        {formData?.[uploadType]?.length > 0 || formData?.[uploadType] ? (
          <button
            disabled={disabled}
            className="rounded-lg border border-sky-200 bg-sky-50 hover:bg-sky-100 text-sky-700 px-3 py-1 text-xs font-semibold shadow-sm transition active:scale-[0.98] disabled:opacity-50"
            onClick={() => {
              uploadType !== 'pictures'
                ? window.open(`${END_POINT}/prescription/get/${formData?.[uploadType]}`)
                : setShowImages(true);
            }}
          >
            VIEW
          </button>
        ) : null}
      </div>

      <div className="noteField">
        <label className="text-sm font-medium text-primary-900 mb-1">Note</label>
        <textarea
          disabled={disabled}
          id={id}
          className="w-full border border-primary-300 text-primary-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 p-2.5 resize-vertical"
          placeholder="Enter Note"
          onChange={handelInputChange}
          value={formData?.[SectionType]}
          name={SectionType}
        />
      </div>

      {isModalOpen !== 'pictures'
        ? <FileUploadModal isOpen={isModalOpen} closeModal={handleCloseModal} onFileUpload={handleFileUpload} uploadType={uploadType} />
        : <ImageUploadModal isOpen={isModalOpen} closeModal={handleCloseModal} onImageUpload={handleImageUpload} />}

      {showImage && <ImageShowModal isOpen={showImage} closeModal={handleImageCloseModal} Images={formData?.[uploadType]} />}
    </div>
  );
};

const tableCellInputClass = 'w-full min-w-0 bg-transparent px-2 py-1.5 text-sm outline-none focus:bg-primary-50 focus:ring-1 focus:ring-inset focus:ring-primary-400 placeholder:text-gray-400 disabled:cursor-not-allowed';

const stickyNameHeadClass = 'sticky left-0 z-20 bg-primary-400';
const stickyNameCellClass = 'sticky left-0 z-[5] bg-white shadow-[1px_0_0_#d1d5db]';

function MedicineTableCard({ title, renderTable, onAdd, disabled }) {
  const [expanded, setExpanded] = useState(false);
  const closeExpanded = useCallback(() => setExpanded(false), []);

  return (
    <div className="border rounded-lg p-2">
      <div className="flex items-center justify-between gap-2 mb-2">
        <h4 className="font-semibold leading-tight">{title}</h4>
        <div className="flex items-center gap-1.5">
          {onAdd && (
            <button
              type="button"
              disabled={disabled}
              onClick={onAdd}
              className="shrink-0 inline-flex items-center gap-1 rounded-md border border-sky-300 bg-sky-50 hover:bg-sky-100 px-2 py-1 text-xs font-semibold text-sky-700 transition-colors disabled:opacity-50 active:scale-[0.98]"
              title={`Add row to ${title}`}
            >
              <FiPlus className="w-3.5 h-3.5" />
              Add
            </button>
          )}
          <button
            type="button"
            onClick={() => setExpanded(true)}
            className="shrink-0 inline-flex items-center gap-1 rounded-md border border-primary-300 bg-white px-2 py-1 text-xs font-semibold text-primary-600 hover:bg-primary-50 transition-colors"
            title="Open in a larger view"
          >
            <FiMaximize2 className="w-3.5 h-3.5" />
            Expand
          </button>
        </div>
      </div>
      <div className="max-h-[30vh] overflow-auto rounded-md border border-gray-200">
        {!expanded && renderTable()}
      </div>
      <p className="mt-1 text-[11px] text-gray-500">Scroll sideways for more columns · Click '+ Add' or Tab on last column to add a row</p>

      <Modal
        isOpen={expanded}
        onClose={closeExpanded}
        title={title}
        subtitle="Click '+ Add' or Tab on the last column to add a row · Changes are saved with the prescription"
        maxWidth="max-w-5xl"
        footer={
          <div className="flex items-center justify-between w-full">
            {onAdd ? (
              <button
                type="button"
                disabled={disabled}
                onClick={onAdd}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-sky-600 hover:bg-sky-700 text-white rounded-lg font-semibold text-xs shadow-sm transition active:scale-[0.98]"
              >
                <FiPlus className="w-3.5 h-3.5" />
                Add Row
              </button>
            ) : <div />}
            <button type="button" onClick={closeExpanded} className="px-5 py-2 bg-blue-800 hover:bg-blue-900 transition-colors rounded-lg font-semibold text-white text-sm">
              Done
            </button>
          </div>
        }
      >
        <div className="rounded-md border border-gray-200 overflow-x-auto">
          {renderTable()}
        </div>
      </Modal>
    </div>
  );
}

const intakeSuggestions = [
  '1-0-1',
  '1-1-1',
  '1-0-0',
  '0-0-1',
  '0-1-0',
  'Once a day',
  'Twice a day',
  'Thrice a day',
  'Before food',
  'After food',
  'Empty stomach',
  'At bedtime',
  'SOS',
];

const commonDurations = [
  '1 week',
  '2 weeks',
  '3 weeks',
  '1 month',
  '2 months',
  '3 months',
  'SOS',
  '3 days',
  '5 days',
  '7 days',
  '10 days',
  '15 days',
];

const commonPotencies = [
  'Q',
  '3X',
  '6X',
  '12X',
  '30C',
  '200C',
  '1M',
  '10M',
  '50M',
  'CM',
  '0/1',
  '0/2',
  '0/3',
  '0/6',
  'LM 1',
  'LM 2',
  'LM 3',
];


const findInventoryMatches = (inventory, name) => {
  const target = (name || '').trim().toLowerCase();
  if (!target) return [];
  return (inventory || []).filter((med) => {
    const medName = (med?.nameOfMedicine || med?.name || '').trim().toLowerCase();
    return medName === target || medName.startsWith(target) || target.startsWith(medName);
  });
};

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

// Inventory keeps an MRP plus an optional percentage discount, so the billable price is the net of the two.
const netPriceOf = (med) => {
  const mrp = toNumber(med?.mrp);
  if (mrp === null) return null;
  const discount = toNumber(med?.discount) || 0;
  // Some stock entries hold a rupee amount or a typo here; anything outside 0–100 is not a usable percentage.
  const net = discount > 0 && discount <= 100 ? mrp - (mrp * discount) / 100 : mrp;
  return Math.round(net * 100) / 100;
};

const lineTotal = (unitPrice, quantity) => {
  const qty = toNumber(quantity);
  const units = qty && qty > 0 ? qty : 1;
  return Math.round(unitPrice * units * 100) / 100;
};

// One suggestion per medicine + potency, because that pair is what a prescription row actually points at.
// Only real stock from the clinic inventory is suggested; anything else still types in as free text.
const buildInventoryOptions = (inventory) => {
  const byKey = new Map();

  (inventory || []).forEach((med) => {
    const name = (med?.nameOfMedicine || med?.name || '').trim();
    if (!name) return;
    const potency = (med?.potencyOrPower || med?.potency || '').trim();
    const key = `${name.toLowerCase()}|${potency.toLowerCase()}`;
    const stock = toNumber(med?.quantity) || 0;
    const existing = byKey.get(key);
    if (existing) {
      existing.stock += stock;
      return;
    }
    const company = (med?.company || '').trim();
    const type = (med?.typeOfMedicine || '').trim();
    byKey.set(key, {
      key,
      name,
      potency,
      company,
      type,
      price: netPriceOf(med),
      stock,
      search: `${name} ${potency} ${company} ${type}`.toLowerCase(),
    });
  });

  return [...byKey.values()].sort((a, b) => a.name.localeCompare(b.name) || a.potency.localeCompare(b.potency));
};

const MAX_SUGGESTIONS = 50;

const filterInventoryOptions = (options, query) => {
  const term = (query || '').trim().toLowerCase();
  if (!term) return (options || []).slice(0, MAX_SUGGESTIONS);

  const tokens = term.split(/\s+/).filter(Boolean);
  const exact = [];
  const startsWith = [];
  const contains = [];

  (options || []).forEach((option) => {
    const optName = option.name.toLowerCase();
    const optSearch = option.search;

    if (optName === term) {
      exact.push(option);
    } else if (optName.startsWith(term)) {
      startsWith.push(option);
    } else if (tokens.every((tok) => optSearch.includes(tok))) {
      contains.push(option);
    }
  });

  return [...exact, ...startsWith, ...contains].slice(0, MAX_SUGGESTIONS);
};

function MedicinePrescriptionTable({ disabled, MedicinePrescription, setFormData, formData, handleTableChange }) {

  const { getallMedicines = [] } = useSelector((state) => state.medicines || {});
  const inventoryOptions = useMemo(() => buildInventoryOptions(getallMedicines), [getallMedicines]);

  const { duration: dropdownDuration = [], potency: dropdownPotency = [] } = useSelector((state) => state?.dropDown?.getallDropDowns?.[0] || { duration: [], potency: [] });

  const durationOptions = useMemo(() => {
    return [...new Set([...(dropdownDuration || []), ...commonDurations])];
  }, [dropdownDuration]);

  const listPrefix = `med-${String(formData?.Date || '').replace(/[^a-zA-Z0-9]/g, '')}`;

  // Picking from the dropdown and typing free text both land here, so rows keep working for off-inventory medicines.
  const rowEvent = { target: { id: formData?.Date, name: 'MedicinePrescription' } };

  const handleMedicineNameChange = (e, index) => {
    const selectedName = e.target.value;
    const matches = findInventoryMatches(getallMedicines, selectedName);
    const potencies = [...new Set(matches.map((med) => med.potencyOrPower).filter(Boolean))];

    const updatedMedicinePrescription = { ...MedicinePrescription };
    const current = updatedMedicinePrescription[index] || {};
    const updated = {
      ...updatedMedicinePrescription,
      [index]: {
        ...current,
        name: selectedName,
        potency: potencies.length === 1 && !current.potency ? potencies[0] : current.potency || '',
      }
    };
    setData(updated);
    handleTableChange(e, updated);
  };

  const handleMedicinePick = (option, index) => {
    const updatedMedicinePrescription = { ...MedicinePrescription };
    const current = updatedMedicinePrescription[index] || {};
    const updated = {
      ...updatedMedicinePrescription,
      [index]: {
        ...current,
        name: option.name,
        potency: option.potency || current.potency || '',
      }
    };
    setData(updated);
    handleTableChange(rowEvent, updated);
  };

  const [data, setData] = useState(MedicinePrescription);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (!MedicinePrescription) {
      // Display a single initial row if MedicinePrescription doesn't exist
      setData({ 0: { name: '', duration: '2 weeks', potency: '', intake: '' } });
    } else {
      setData(MedicinePrescription);
    }
  }, [MedicinePrescription]);

  const addRow = (e, targetIndex = null) => {
    const current = MedicinePrescription || data || {};
    const keys = Object.keys(current).map(Number).filter((n) => !isNaN(n));
    const newIndex = targetIndex !== null && targetIndex !== undefined
      ? targetIndex
      : (keys.length ? Math.max(...keys) + 1 : Object.keys(current).length);
    const updatedData = { ...current, [newIndex]: { name: '', duration: '2 weeks', potency: '', intake: '' } };
    setData(updatedData);
    handleTableChange(e?.target?.id ? e : rowEvent, updatedData);
    setTimeout(() => focusOnInput(newIndex), 0);
  };

  const removeRow = (e, index) => {
    const current = MedicinePrescription || data || {};
    if (Object.keys(current).length <= 1) return; // Ensure at least one row remains
    const updatedMedicinePrescription = { ...current };
    delete updatedMedicinePrescription[index];
    const newData = { ...(data || {}) };
    delete newData[index];
    setData(newData);
    handleTableChange(e?.target?.id ? e : rowEvent, updatedMedicinePrescription);
    const remainingKeys = Object.keys(newData);
    if (remainingKeys.length > 0) {
      focusOnInput(remainingKeys[remainingKeys.length - 1]);
    }
  };

  const handleFieldChange = (e, index, field) => {
    const updatedMedicinePrescription = { ...MedicinePrescription };
    if (updatedMedicinePrescription[index]) {
      const updated = {
        ...updatedMedicinePrescription,
        [index]: {
          ...updatedMedicinePrescription[index],
          [field]: e.target.value,
        }
      };
      setData(updated);
      handleTableChange(e, updated);
    }
  };

  const handleRowKeys = (e, index, addOnTab = false) => {
    if (e.key === 'Tab' && addOnTab) {
      addRow(e);
      e.preventDefault();
    } else if (e.key === 'Delete') {
      removeRow(e, index);
      e.preventDefault();
    }
  };

  const focusOnInput = (index) => {
    if (inputRefs.current[index]) {
      inputRefs.current[index].focus();
    }
  };

  return (
    <div>
      <table className="w-full min-w-[580px] table-fixed text-sm">
        <thead className="sticky top-0 z-10">
          <tr className="text-left text-xs bg-primary-400 font-semibold text-primary-50 uppercase tracking-wider">
            <th className={`px-2 py-1.5 border border-gray-300 w-[32%] ${stickyNameHeadClass}`}>Name</th>
            <th className="px-2 py-1.5 border border-gray-300 w-[18%]">Potency</th>
            <th className="px-2 py-1.5 border border-gray-300 w-[20%]">Duration</th>
            <th className="px-2 py-1.5 border border-gray-300 w-[24%]">Intake</th>
            <th className="px-1 py-1.5 border border-gray-300 w-[6%] text-center">
              <button
                type="button"
                disabled={disabled}
                onClick={() => addRow(rowEvent)}
                className="inline-flex items-center justify-center p-0.5 rounded hover:bg-primary-500 text-primary-50 transition-colors disabled:opacity-50"
                title="Add medicine"
              >
                <FiPlus className="w-3.5 h-3.5" />
              </button>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {Object.entries(data || {}).map(([index, row]) => {
            const invPotencies = findInventoryMatches(getallMedicines, row?.name).map((med) => med.potencyOrPower).filter(Boolean);
            const potencyOptions = [...new Set([...invPotencies, ...(dropdownPotency || []), ...commonPotencies])];
            return (
              <tr key={index} className="hover:bg-primary-50">
                <td className={`p-0 ${stickyNameCellClass}`}>
                  <MedicineNameSuggestion disabled={disabled} id={formData?.Date} value={row?.name} onChange={(e) => handleMedicineNameChange(e, index)} onPick={(option) => handleMedicinePick(option, index)} options={inventoryOptions} name={'MedicinePrescription'} inputRef={(input) => (inputRefs.current[index] = input)} />
                </td>
                <td className="p-0 border-l border-gray-300">
                  <input
                    disabled={disabled}
                    type="text"
                    className={tableCellInputClass}
                    name="MedicinePrescription"
                    id={formData?.Date}
                    value={row?.potency || ''}
                    placeholder="e.g. 30C, 200C"
                    onChange={(e) => handleFieldChange(e, index, 'potency')}
                    onKeyDown={(e) => handleRowKeys(e, index)}
                    list={`${listPrefix}-potency-${index}`}
                  />
                  <datalist id={`${listPrefix}-potency-${index}`}>
                    {potencyOptions.map((suggestion) => (
                      <option key={suggestion} value={suggestion} />
                    ))}
                  </datalist>
                </td>
                <td className="p-0 border-l border-gray-300">
                  <input
                    disabled={disabled}
                    type="text"
                    className={tableCellInputClass}
                    name="MedicinePrescription"
                    id={formData?.Date}
                    value={row?.duration || ''}
                    onChange={(e) => handleFieldChange(e, index, 'duration')}
                    onKeyDown={(e) => handleRowKeys(e, index)}
                    list={`${listPrefix}-duration`}
                  />
                </td>
                <td className="p-0 border-l border-gray-300">
                  <input
                    disabled={disabled}
                    type="text"
                    className={tableCellInputClass}
                    name="MedicinePrescription"
                    id={formData?.Date}
                    value={row?.intake || ''}
                    placeholder="e.g. 1-0-1"
                    onChange={(e) => handleFieldChange(e, index, 'intake')}
                    onKeyDown={(e) => handleRowKeys(e, index, true)}
                    list={`${listPrefix}-intake`}
                  />
                </td>
                <td className="p-0 border-l border-gray-300 text-center">
                  {Object.keys(data || {}).length > 1 ? (
                    <button
                      type="button"
                      disabled={disabled}
                      onClick={() => removeRow(rowEvent, index)}
                      className="p-1 text-gray-400 hover:text-rose-600 transition-colors disabled:opacity-40"
                      title="Remove medicine"
                    >
                      <FiTrash2 className="w-3.5 h-3.5 mx-auto" />
                    </button>
                  ) : null}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr className="bg-gray-50 text-xs font-semibold text-gray-700">
            <td className="px-2 py-1.5 sticky left-0 z-[5] bg-gray-50 shadow-[1px_0_0_#d1d5db]">
              <button
                type="button"
                disabled={disabled}
                onClick={() => addRow(rowEvent)}
                className="inline-flex items-center gap-1.5 text-sky-600 hover:text-sky-800 font-semibold disabled:text-gray-400 disabled:cursor-not-allowed transition-colors"
              >
                <FiPlus className="w-3.5 h-3.5" />
                <span>+ Add Medicine</span>
              </button>
            </td>
            <td colSpan={4} className="px-2 py-1.5 border-l border-gray-300 text-gray-400 text-[11px]">
              Tab on last field or click button to add
            </td>
          </tr>
        </tfoot>
      </table>
      <datalist id={`${listPrefix}-duration`}>
        {durationOptions.map((suggestion, index) => (
          <option key={index} value={suggestion} />
        ))}
      </datalist>
      <datalist id={`${listPrefix}-intake`}>
        {intakeSuggestions.map((suggestion) => (
          <option key={suggestion} value={suggestion} />
        ))}
      </datalist>
    </div>
  );
}

function SupplimentoryMedicineTable({ disabled, SupplimentoryMedicine, setFormData, formData, handleTableChange }) {
  const { getallMedicines = [] } = useSelector((state) => state.medicines || {});
  const inventoryOptions = useMemo(() => buildInventoryOptions(getallMedicines), [getallMedicines]);

  const { duration: dropdownDuration = [] } = useSelector((state) => state?.dropDown?.getallDropDowns?.[0] || { duration: [] });

  const durationOptions = useMemo(() => {
    return [...new Set([...(dropdownDuration || []), ...commonDurations])];
  }, [dropdownDuration]);

  const listPrefix = `supp-${String(formData?.Date || '').replace(/[^a-zA-Z0-9]/g, '')}`;

  const rowEvent = { target: { id: formData?.Date, name: 'SupplimentoryMedicine' } };

  // Unit prices stay out of the saved row (the schema only keeps the columns below) but let QTY recalculate the fee.
  const unitPriceRef = useRef({});

  const handleMedicineNameChange = (e, index) => {
    const updatedSupplimentoryMedicine = { ...SupplimentoryMedicine };
    const current = updatedSupplimentoryMedicine[index] || {};
    delete unitPriceRef.current[index];
    const updated = { ...updatedSupplimentoryMedicine, [index]: { ...current, name: e.target.value } };
    setData(updated);
    handleTableChange(e, updated);
  };

  const handleMedicinePick = (option, index) => {
    const updatedSupplimentoryMedicine = { ...SupplimentoryMedicine };
    const current = updatedSupplimentoryMedicine[index] || {};
    const quantity = current.quantity || '1';

    if (option.price === null) {
      delete unitPriceRef.current[index];
    } else {
      unitPriceRef.current[index] = option.price;
    }

    const updated = {
      ...updatedSupplimentoryMedicine,
      [index]: {
        ...current,
        // There is no potency column here, so the power stays part of the name.
        name: [option.name, option.potency].filter(Boolean).join(' '),
        quantity,
        fees: option.price === null ? current.fees || '' : String(lineTotal(option.price, quantity)),
      }
    };
    setData(updated);
    handleTableChange(rowEvent, updated);
  };

  const [data, setData] = useState(SupplimentoryMedicine);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (!SupplimentoryMedicine) {
      // Display a single initial row if SupplimentoryMedicine doesn't exist
      setData({ 0: { name: '', duration: '', intake: '', fees: '', quantity: '' } });
    } else {
      setData(SupplimentoryMedicine);
    }
  }, [SupplimentoryMedicine]);

  const addRow = (e, targetIndex = null) => {
    const current = SupplimentoryMedicine || data || {};
    const keys = Object.keys(current).map(Number).filter((n) => !isNaN(n));
    const newIndex = targetIndex !== null && targetIndex !== undefined
      ? targetIndex
      : (keys.length ? Math.max(...keys) + 1 : Object.keys(current).length);
    let updatedData = { ...current, [newIndex]: { name: '', duration: '', intake: '', fees: '', quantity: '' } };
    setData(updatedData);
    handleTableChange(e?.target?.id ? e : rowEvent, updatedData);
    setTimeout(() => focusOnInput(newIndex), 0);
  };

  const removeRow = (e, index) => {
    const current = SupplimentoryMedicine || data || {};
    if (Object.keys(current).length <= 1) return; // Ensure at least one row remains
    const updatedMedicinePrescription = { ...current };
    delete updatedMedicinePrescription[index];
    delete unitPriceRef.current[index];
    const newData = { ...(data || {}) };
    delete newData[index];
    setData(newData);
    handleTableChange(e?.target?.id ? e : rowEvent, updatedMedicinePrescription);
    const remainingKeys = Object.keys(newData);
    if (remainingKeys.length > 0) {
      focusOnInput(remainingKeys[remainingKeys.length - 1]);
    }
  };

  const handleFieldChange = (e, index, field) => {
    const updatedSupplimentoryMedicine = { ...SupplimentoryMedicine };
    if (updatedSupplimentoryMedicine[index]) {
      const nextRow = {
        ...updatedSupplimentoryMedicine[index],
        [field]: e.target.value,
      };
      const unitPrice = unitPriceRef.current[index];
      if (field === 'quantity' && unitPrice != null) {
        nextRow.fees = String(lineTotal(unitPrice, e.target.value));
      }
      if (field === 'fees') {
        // A hand-typed fee wins over the inventory price from then on.
        delete unitPriceRef.current[index];
      }
      const updated = { ...updatedSupplimentoryMedicine, [index]: nextRow };
      setData(updated);
      handleTableChange(e, updated);
    }
  };

  const handleRowKeys = (e, index, addOnTab = false) => {
    if (e.key === 'Tab' && addOnTab) {
      addRow(e);
      e.preventDefault();
    } else if (e.key === 'Delete') {
      removeRow(e, index);
      e.preventDefault();
    }
  };

  const focusOnInput = (index) => {
    if (inputRefs.current[index]) {
      inputRefs.current[index].focus();
    }
  };

  return (
    <div>
      <table className="w-full min-w-[660px] table-fixed text-sm">
        <thead className="sticky top-0 z-10">
          <tr className="text-left text-xs bg-primary-400 font-semibold text-primary-50 uppercase tracking-wider">
            <th className={`px-2 py-1.5 border border-gray-300 w-[26%] ${stickyNameHeadClass}`}>Name</th>
            <th className="px-2 py-1.5 border border-gray-300 w-[18%]">Duration</th>
            <th className="px-2 py-1.5 border border-gray-300 w-[20%]">Intake</th>
            <th className="px-2 py-1.5 border border-gray-300 w-[15%]">Fees</th>
            <th className="px-2 py-1.5 border border-gray-300 w-[15%]">QTY</th>
            <th className="px-1 py-1.5 border border-gray-300 w-[6%] text-center">
              <button
                type="button"
                disabled={disabled}
                onClick={() => addRow(rowEvent)}
                className="inline-flex items-center justify-center p-0.5 rounded hover:bg-primary-500 text-primary-50 transition-colors disabled:opacity-50"
                title="Add supplementary medicine"
              >
                <FiPlus className="w-3.5 h-3.5" />
              </button>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {Object.entries(data || {}).map(([index, row]) => (
            <tr key={index} className="hover:bg-primary-50">
              <td className={`p-0 ${stickyNameCellClass}`}>
                <MedicineNameSuggestion disabled={disabled} id={formData?.Date} value={row?.name} onChange={(e) => handleMedicineNameChange(e, index)} onPick={(option) => handleMedicinePick(option, index)} options={inventoryOptions} name="SupplimentoryMedicine" inputRef={(input) => (inputRefs.current[index] = input)} />
              </td>
              <td className="p-0 border-l border-gray-300">
                <input disabled={disabled} id={formData?.Date} name="SupplimentoryMedicine" type="text" className={tableCellInputClass} value={row?.duration || ''} onChange={(e) => handleFieldChange(e, index, 'duration')} onKeyDown={(e) => handleRowKeys(e, index)} list={`${listPrefix}-duration`} />
              </td>
              <td className="p-0 border-l border-gray-300">
                <input disabled={disabled} id={formData?.Date} name="SupplimentoryMedicine" type="text" className={tableCellInputClass} value={row?.intake || ''} placeholder="e.g. 1-0-1" onChange={(e) => handleFieldChange(e, index, 'intake')} onKeyDown={(e) => handleRowKeys(e, index)} list={`${listPrefix}-intake`} />
              </td>
              <td className="p-0 border-l border-gray-300">
                <input disabled={disabled} id={formData?.Date} name="SupplimentoryMedicine" type="text" className={tableCellInputClass} value={row?.fees || ''} onChange={(e) => handleFieldChange(e, index, 'fees')} onKeyDown={(e) => handleRowKeys(e, index)} />
              </td>
              <td className="p-0 border-l border-gray-300">
                <input disabled={disabled} id={formData?.Date} name="SupplimentoryMedicine" type="text" className={tableCellInputClass} value={row?.quantity || ''} onChange={(e) => handleFieldChange(e, index, 'quantity')} onKeyDown={(e) => handleRowKeys(e, index, true)} />
              </td>
              <td className="p-0 border-l border-gray-300 text-center">
                {Object.keys(data || {}).length > 1 ? (
                  <button
                    type="button"
                    disabled={disabled}
                    onClick={() => removeRow(rowEvent, index)}
                    className="p-1 text-gray-400 hover:text-rose-600 transition-colors disabled:opacity-40"
                    title="Remove medicine"
                  >
                    <FiTrash2 className="w-3.5 h-3.5 mx-auto" />
                  </button>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="bg-gray-50 text-xs font-semibold text-gray-700">
            <td className="px-2 py-1.5 sticky left-0 z-[5] bg-gray-50 shadow-[1px_0_0_#d1d5db]">
              <button
                type="button"
                disabled={disabled}
                onClick={() => addRow(rowEvent)}
                className="inline-flex items-center gap-1.5 text-sky-600 hover:text-sky-800 font-semibold disabled:text-gray-400 disabled:cursor-not-allowed transition-colors"
              >
                <FiPlus className="w-3.5 h-3.5" />
                <span>+ Add Medicine</span>
              </button>
            </td>
            <td colSpan={5} className="px-2 py-1.5 border-l border-gray-300 text-gray-400 text-[11px]">
              Tab on last field or click button to add
            </td>
          </tr>
        </tfoot>
      </table>
      <datalist id={`${listPrefix}-duration`}>
        {durationOptions.map((suggestion, index) => (
          <option key={index} value={suggestion} />
        ))}
      </datalist>
      <datalist id={`${listPrefix}-intake`}>
        {intakeSuggestions.map((suggestion) => (
          <option key={suggestion} value={suggestion} />
        ))}
      </datalist>
    </div>
  );
}

const emptyPathologicalRow = { name: '', referredTo: '', amount: '', remarks: '' };

// Seed list so the very first prescription still gets suggestions; clinic-specific names
// come from the prescriptions already saved (see /prescription/pathological-options).
const commonPathologicalTests = [
  'CBC (Complete Blood Count)',
  'ESR',
  'Blood Sugar (Fasting)',
  'Blood Sugar (Post Prandial)',
  'HbA1c',
  'Lipid Profile',
  'Liver Function Test (LFT)',
  'Kidney Function Test (KFT)',
  'Thyroid Profile (T3 T4 TSH)',
  'Urine Routine & Microscopy',
  'Stool Routine',
  'Vitamin B12',
  'Vitamin D3',
  'Serum Calcium',
  'Serum Uric Acid',
  'Serum Iron / Ferritin',
  'CRP',
  'Widal Test',
  'X-Ray',
  'USG (Ultrasound)',
];

// Shared by every prescription row on screen so one render is one request, but only for a
// few seconds: this module outlives navigation in the SPA, so an unbounded cache would keep
// serving a list from before the user went and registered a referral business.
const PATHOLOGICAL_OPTIONS_TTL = 15000;

let pathologicalOptionsPromise = null;
let pathologicalOptionsFetchedAt = 0;

const fetchPathologicalOptions = () => {
  const expired = Date.now() - pathologicalOptionsFetchedAt > PATHOLOGICAL_OPTIONS_TTL;

  if (!pathologicalOptionsPromise || expired) {
    pathologicalOptionsFetchedAt = Date.now();
    pathologicalOptionsPromise = axios
      .get(`${END_POINT}/prescription/pathological-options`, { headers: { Authorization: getJwtToken() } })
      .then(({ data }) => ({
        tests: data?.tests || [],
        centres: data?.centres || [],
        businesses: data?.businesses || [],
      }))
      .catch((error) => {
        // A failure here silently empties the referral dropdown, so make it visible rather
        // than letting it look like there are simply no businesses.
        console.error('Could not load pathological test options:', error?.response?.data || error?.message);
        pathologicalOptionsPromise = null;
        pathologicalOptionsFetchedAt = 0;
        return { tests: [], centres: [], businesses: [] };
      });
  }
  return pathologicalOptionsPromise;
};

function usePathologicalOptions() {
  const [options, setOptions] = useState({ tests: [], centres: [], businesses: [] });
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let active = true;
    fetchPathologicalOptions().then((result) => {
      if (active) setOptions(result);
    });
    return () => {
      active = false;
    };
  }, [version]);

  const reload = useCallback(() => {
    pathologicalOptionsPromise = null;
    pathologicalOptionsFetchedAt = 0;
    setVersion((current) => current + 1);
  }, []);

  return useMemo(() => {
    const registered = new Map(
      (options.businesses || []).map((business) => [
        business.name.toLowerCase(),
        {
          name: business.name,
          search: `${business.name} ${business.type || ''}`.toLowerCase(),
          registered: true,
          hasEmail: Boolean(business.hasEmail),
          type: business.type,
        },
      ]),
    );

    (options.centres || []).forEach((centre) => {
      const key = centre.toLowerCase();
      if (registered.has(key)) return;
      registered.set(key, { name: centre, search: centre.toLowerCase(), registered: false, hasEmail: false });
    });

    return {
      tests: [...new Set([...options.tests, ...commonPathologicalTests])].sort((a, b) => a.localeCompare(b)),
      centres: options.centres,
      centreOptions: [...registered.values()].sort((a, b) => {
        if (a.registered !== b.registered) return a.registered ? -1 : 1;
        return a.name.localeCompare(b.name);
      }),
      reload,
    };
  }, [options, reload]);
}

// Pathology advised on the report prescription. Each row also carries the lab/centre the
// test is referred to and its amount, which is what the referral business is tracked on.
function PathologicalTestTable({ disabled, PathologicalTests, formData, handleTableChange }) {
  const { tests: testSuggestions, centreOptions, reload: reloadReferralOptions } = usePathologicalOptions();
  const inputRefs = useRef([]);
  const listPrefix = `pathological-${formData?.Date || 'new'}`;

  // An empty prescription has no map yet, so fall back to a single blank row to type into.
  const rows = PathologicalTests && Object.keys(PathologicalTests).length ? PathologicalTests : { 0: { ...emptyPathologicalRow } };

  const rowEvent = { target: { id: formData?.Date, name: 'PathologicalTests' } };

  const referralTotal = Object.values(rows).reduce((sum, row) => {
    const amount = Number(row?.amount);
    return Number.isFinite(amount) ? sum + amount : sum;
  }, 0);

  const handleFieldChange = (e, index, field) => {
    const updated = { ...rows, [index]: { ...(rows[index] || emptyPathologicalRow), [field]: e.target.value } };
    handleTableChange(e, updated);
  };

  const addRow = (e) => {
    const keys = Object.keys(rows).map(Number).filter((n) => !isNaN(n));
    const newIndex = keys.length ? Math.max(...keys) + 1 : Object.keys(rows).length;
    handleTableChange(e?.target?.id ? e : rowEvent, { ...rows, [newIndex]: { ...emptyPathologicalRow } });
    setTimeout(() => inputRefs.current[newIndex]?.focus(), 0);
  };

  const removeRow = (e, index) => {
    if (Object.keys(rows).length <= 1) return; // Ensure at least one row remains
    const updated = { ...rows };
    delete updated[index];
    handleTableChange(e?.target?.id ? e : rowEvent, updated);
  };

  const handleRowKeys = (e, index, addOnTab = false) => {
    if (e.key === 'Tab' && addOnTab && !e.shiftKey) {
      addRow(e);
      e.preventDefault();
    } else if (e.key === 'Delete') {
      removeRow(e, index);
      e.preventDefault();
    }
  };

  return (
    <div>
      <table className="w-full min-w-[620px] table-fixed text-sm">
        <thead className="sticky top-0 z-10">
          <tr className="text-left text-xs bg-primary-400 font-semibold text-primary-50 uppercase tracking-wider">
            <th className={`px-2 py-1.5 border border-gray-300 w-[30%] ${stickyNameHeadClass}`}>Test</th>
            <th className="px-2 py-1.5 border border-gray-300 w-[26%]">Referred To</th>
            <th className="px-2 py-1.5 border border-gray-300 w-[16%]">Amount</th>
            <th className="px-2 py-1.5 border border-gray-300 w-[22%]">Remarks</th>
            <th className="px-1 py-1.5 border border-gray-300 w-[6%] text-center">
              <button
                type="button"
                disabled={disabled}
                onClick={() => addRow(rowEvent)}
                className="inline-flex items-center justify-center p-0.5 rounded hover:bg-primary-500 text-primary-50 transition-colors disabled:opacity-50"
                title="Add test"
              >
                <FiPlus className="w-3.5 h-3.5" />
              </button>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {Object.entries(rows).map(([index, row]) => (
            <tr key={index} className="hover:bg-primary-50">
              <td className={`p-0 ${stickyNameCellClass}`}>
                <input
                  disabled={disabled}
                  id={formData?.Date}
                  name="PathologicalTests"
                  type="text"
                  className={tableCellInputClass}
                  placeholder="e.g. CBC"
                  value={row?.name || ''}
                  onChange={(e) => handleFieldChange(e, index, 'name')}
                  onKeyDown={(e) => handleRowKeys(e, index)}
                  ref={(input) => (inputRefs.current[index] = input)}
                  list={`${listPrefix}-tests`}
                />
              </td>
              <td className="p-0 border-l border-gray-300">
                <ReferralBusinessSuggestion
                  disabled={disabled}
                  id={formData?.Date}
                  name="PathologicalTests"
                  options={centreOptions}
                  onCreated={reloadReferralOptions}
                  value={row?.referredTo || ''}
                  onChange={(e) =>
                    handleFieldChange(
                      { ...e, target: { ...e.target, id: formData?.Date, name: 'PathologicalTests', value: e.target.value } },
                      index,
                      'referredTo',
                    )
                  }
                  onKeyDown={(e) => handleRowKeys(e, index)}
                />
              </td>
              <td className="p-0 border-l border-gray-300">
                <input
                  disabled={disabled}
                  id={formData?.Date}
                  name="PathologicalTests"
                  type="number"
                  className={tableCellInputClass}
                  value={row?.amount || ''}
                  onChange={(e) => handleFieldChange(e, index, 'amount')}
                  onKeyDown={(e) => handleRowKeys(e, index)}
                />
              </td>
              <td className="p-0 border-l border-gray-300">
                <input
                  disabled={disabled}
                  id={formData?.Date}
                  name="PathologicalTests"
                  type="text"
                  className={tableCellInputClass}
                  value={row?.remarks || ''}
                  onChange={(e) => handleFieldChange(e, index, 'remarks')}
                  onKeyDown={(e) => handleRowKeys(e, index, true)}
                />
              </td>
              <td className="p-0 border-l border-gray-300 text-center">
                {Object.keys(rows).length > 1 ? (
                  <button
                    type="button"
                    disabled={disabled}
                    onClick={() => removeRow(rowEvent, index)}
                    className="p-1 text-gray-400 hover:text-rose-600 transition-colors disabled:opacity-40"
                    title="Remove test"
                  >
                    <FiTrash2 className="w-3.5 h-3.5 mx-auto" />
                  </button>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="bg-gray-50 text-xs font-semibold text-gray-700">
            <td className="px-2 py-1.5 sticky left-0 z-[5] bg-gray-50 shadow-[1px_0_0_#d1d5db]">
              <button
                type="button"
                disabled={disabled}
                onClick={() => addRow(rowEvent)}
                className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-800 font-semibold disabled:text-gray-400 disabled:cursor-not-allowed"
              >
                <FiPlus className="w-3.5 h-3.5" />
                <span>+ Add test</span>
              </button>
            </td>
            <td className="px-2 py-1.5 text-right border-l border-gray-300">Referral Total</td>
            <td className="px-2 py-1.5 border-l border-gray-300">{referralTotal ? referralTotal.toFixed(2) : '-'}</td>
            <td colSpan={2} className="px-2 py-1.5 border-l border-gray-300"></td>
          </tr>
        </tfoot>
      </table>
      <datalist id={`${listPrefix}-tests`}>
        {testSuggestions.map((suggestion) => (
          <option key={suggestion} value={suggestion} />
        ))}
      </datalist>
    </div>
  );
}

const LAB_STATUS_STYLES = {
  pending: 'bg-amber-100 text-amber-700',
  sent: 'bg-sky-100 text-sky-700',
  uploaded: 'bg-emerald-100 text-emerald-700',
  failed: 'bg-rose-100 text-rose-700',
  cancelled: 'bg-slate-200 text-slate-600',
};

// Reports the referred labs have sent back through their one-time upload link, shown against
// the prescription that advised the tests. The same files also land on the patient profile.
function LabReportUploads({ prescriptionId, patientId }) {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busyId, setBusyId] = useState(null);

  const load = useCallback(async () => {
    if (!prescriptionId && !patientId) return;
    setLoading(true);
    try {
      setRequests(await fetchLabRequests(prescriptionId ? { prescriptionId } : { patientId }));
    } catch (e) {
      setRequests([]);
    } finally {
      setLoading(false);
    }
  }, [prescriptionId, patientId]);

  useEffect(() => {
    load();
  }, [load]);

  const resend = async (id) => {
    setBusyId(id);
    try {
      const res = await resendLabRequest(id);
      toast.success(res?.message || 'Upload link sent');
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Could not send the upload link');
    } finally {
      setBusyId(null);
    }
  };

  if (!prescriptionId && !patientId) return null;
  if (!loading && !requests.length) return null;

  return (
    <div className="mt-3 rounded-lg border border-gray-200 bg-white p-3">
      <div className="mb-2 flex items-center justify-between">
        <h4 className="text-xs font-semibold uppercase tracking-wider text-gray-600">Lab Reports</h4>
        <button type="button" onClick={load} className="text-[11px] text-primary-600 hover:underline">
          Refresh
        </button>
      </div>

      {loading ? (
        <p className="py-2 text-xs text-gray-400">Loading…</p>
      ) : (
        <ul className="space-y-2">
          {requests.map((request) => (
            <li key={request._id} className="rounded-md border border-gray-100 bg-gray-50 p-2">
              <div className="flex items-center justify-between gap-2">
                <span className="truncate text-xs font-medium text-gray-800">{request.businessName}</span>
                <span className={`shrink-0 rounded-full px-1.5 py-0.5 text-[10px] font-medium ${LAB_STATUS_STYLES[request.status] || ''}`}>
                  {request.status}
                </span>
              </div>

              <p className="mt-0.5 truncate text-[11px] text-gray-500">{(request.tests || []).join(', ')}</p>

              {(request.documents || []).length ? (
                <div className="mt-1.5 space-y-1">
                  {request.documents.map((doc) => (
                    <button
                      key={String(doc.documentId)}
                      type="button"
                      onClick={() => openLabDocument(doc.documentId)}
                      className="flex items-center gap-1.5 text-[11px] text-primary-600 hover:underline"
                    >
                      <FiFileText className="h-3 w-3" />
                      <span className="truncate">{doc.filename || 'Report'}</span>
                    </button>
                  ))}
                </div>
              ) : (
                <button
                  type="button"
                  disabled={busyId === request._id}
                  onClick={() => resend(request._id)}
                  className="mt-1.5 text-[11px] text-primary-600 hover:underline disabled:opacity-50"
                >
                  {request.status === 'sent' ? 'Resend upload link' : 'Send upload link'}
                </button>
              )}

              {request.lastError ? <p className="mt-1 text-[11px] text-rose-600">{request.lastError}</p> : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function QuickAddReferralBusiness({ initialName, onClose, onCreated }) {
  const [name, setName] = useState(initialName || '');
  const [email, setEmail] = useState('');
  const [type, setType] = useState('lab');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!name.trim()) return toast.error('Business name is required');
    setSaving(true);
    try {
      const created = await createReferralBusiness({ name: name.trim(), email: email.trim(), type });
      toast.success(`${created?.name || name} added to referral businesses`);
      onCreated(created?.name || name.trim());
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Could not add the referral business');
    } finally {
      setSaving(false);
    }
  };

  return createPortal(
    <div className={`fixed inset-0 ${NESTED_MODAL_Z} flex items-center justify-center p-4`}>
      <div className="absolute inset-0 bg-slate-900/60" onClick={onClose} />
      <div className="relative w-full max-w-md rounded-xl bg-white p-5 shadow-2xl">
        <h3 className="text-sm font-semibold text-gray-800">Add referral business</h3>
        <p className="mt-1 text-xs text-gray-500">
          Give it an email and the lab is sent a one-time upload link whenever a test is referred here.
        </p>

        <div className="mt-4 space-y-3">
          <div>
            <label className="mb-1 block text-xs font-medium text-gray-700">Business name</label>
            <input
              autoFocus
              className="w-full rounded-md border border-gray-300 p-2 text-sm"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium text-gray-700">Email</label>
            <input
              type="email"
              className="w-full rounded-md border border-gray-300 p-2 text-sm"
              placeholder="reports@lab.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium text-gray-700">Type</label>
            <select className="w-full rounded-md border border-gray-300 p-2 text-sm" value={type} onChange={(e) => setType(e.target.value)}>
              {REFERRAL_BUSINESS_TYPES.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="mt-5 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded-md border border-gray-300 px-3 py-1.5 text-sm hover:bg-gray-50">
            Cancel
          </button>
          <button
            type="button"
            disabled={saving}
            onClick={save}
            className="rounded-md bg-primary-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-50"
          >
            {saving ? 'Saving…' : 'Add business'}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

// The lab a test is referred to. Registered businesses come first and are badged with whether
// an upload link can actually be emailed to them; anything typed that is not on the list can be
// registered from here, so the doctor never has to leave the prescription to set one up.
function ReferralBusinessSuggestion({ disabled, value, onChange, options, id, name, onKeyDown, onCreated }) {
  const [open, setOpen] = useState(false);
  const [highlight, setHighlight] = useState(0);
  const [position, setPosition] = useState(null);
  const [quickAdd, setQuickAdd] = useState(null);
  const inputEl = useRef(null);
  const blurTimer = useRef(null);

  const matches = open ? filterInventoryOptions(options, value) : [];
  const typed = String(value || '').trim();
  const exactMatch = (options || []).some((option) => option.name.toLowerCase() === typed.toLowerCase());
  const canAdd = !exactMatch;

  const syncPosition = useCallback(() => {
    const el = inputEl.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const dropdownHeight = 240;
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const showAbove = spaceBelow < dropdownHeight && spaceAbove > spaceBelow;
    const top = showAbove
      ? Math.max(10, rect.top - dropdownHeight - 4)
      : Math.min(window.innerHeight - dropdownHeight - 10, rect.bottom + 2);
    const width = Math.max(rect.width, 260);
    const left = Math.max(10, Math.min(rect.left, window.innerWidth - width - 10));

    setPosition({
      top,
      left,
      width,
      maxHeight: Math.min(256, Math.max(120, showAbove ? spaceAbove - 20 : spaceBelow - 20)),
    });
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    syncPosition();
    const handleViewportChange = () => syncPosition();
    window.addEventListener('scroll', handleViewportChange, true);
    window.addEventListener('resize', handleViewportChange);
    return () => {
      window.removeEventListener('scroll', handleViewportChange, true);
      window.removeEventListener('resize', handleViewportChange);
    };
  }, [open, syncPosition]);

  useEffect(() => {
    setHighlight(0);
  }, [value]);

  const pick = (option) => {
    if (!option) return;
    setOpen(false);
    onChange({ target: { value: option.name } });
  };

  const openQuickAdd = () => {
    setOpen(false);
    setQuickAdd(typed);
  };

  const handleKeyDown = (e) => {
    if (open && matches.length) {
      if (e.key === 'ArrowDown') {
        setHighlight((prev) => (prev + 1) % matches.length);
        return e.preventDefault();
      }
      if (e.key === 'ArrowUp') {
        setHighlight((prev) => (prev - 1 + matches.length) % matches.length);
        return e.preventDefault();
      }
      if (e.key === 'Enter' && matches[highlight]) {
        pick(matches[highlight]);
        return e.preventDefault();
      }
      if (e.key === 'Escape') {
        setOpen(false);
        return e.preventDefault();
      }
    } else if (e.key === 'ArrowDown') {
      syncPosition();
      setOpen(true);
      return e.preventDefault();
    }
    return onKeyDown?.(e);
  };

  return (
    <div className="relative">
      <input
        disabled={disabled}
        id={id}
        name={name}
        type="text"
        className={tableCellInputClass}
        placeholder="Lab / centre"
        autoComplete="off"
        value={value || ''}
        ref={inputEl}
        onChange={(e) => {
          syncPosition();
          setOpen(true);
          onChange(e);
        }}
        onFocus={() => {
          if (blurTimer.current) clearTimeout(blurTimer.current);
          syncPosition();
          setOpen(true);
        }}
        onClick={() => {
          if (!open) {
            syncPosition();
            setOpen(true);
          }
        }}
        onBlur={() => {
          blurTimer.current = setTimeout(() => setOpen(false), 200);
        }}
        onKeyDown={handleKeyDown}
      />

      {open && position
        ? createPortal(
          <div
            className={`fixed ${DROPDOWN_Z} overflow-auto rounded-md border border-gray-200 bg-white py-1 text-sm shadow-lg`}
            style={{ top: position.top, left: position.left, width: position.width, maxHeight: position.maxHeight || 256 }}
            onMouseDown={(e) => e.preventDefault()}
          >
            {matches.length ? (
              <ul>
                {matches.map((option, index) => (
                  <li key={option.name}>
                    <button
                      type="button"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        pick(option);
                      }}
                      onMouseEnter={() => setHighlight(index)}
                      className={`flex w-full items-center justify-between gap-3 px-2 py-1.5 text-left transition-colors ${index === highlight ? 'bg-primary-50' : 'bg-white hover:bg-gray-50'}`}
                    >
                      <span className="truncate">{option.name}</span>
                      {option.registered ? (
                        <span className={`shrink-0 rounded-full px-1.5 py-0.5 text-[10px] font-medium ${option.hasEmail ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`}>
                          {option.hasEmail ? 'auto email' : 'no email'}
                        </span>
                      ) : (
                        <span className="shrink-0 text-[10px] text-gray-400">past entry</span>
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="px-2 py-2 text-xs text-gray-400">
                {typed ? 'No matching referral business' : 'No referral businesses added yet'}
              </p>
            )}

            {canAdd ? (
              <button
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  openQuickAdd();
                }}
                className="mt-1 flex w-full items-center gap-1.5 border-t border-gray-100 px-2 py-1.5 text-left text-xs font-medium text-primary-600 hover:bg-primary-50"
              >
                <FiPlus className="h-3.5 w-3.5" />
                {typed ? `Add "${typed}" as a referral business` : 'Add a referral business'}
              </button>
            ) : null}
          </div>,
          document.body,
        )
        : null}

      {quickAdd !== null ? (
        <QuickAddReferralBusiness
          initialName={quickAdd}
          onClose={() => setQuickAdd(null)}
          onCreated={(createdName) => {
            setQuickAdd(null);
            onChange({ target: { value: createdName } });
            onCreated?.();
          }}
        />
      ) : null}
    </div>
  );
}

function MedicineNameSuggestion({ disabled, value, onChange, onPick, options, id, name, inputRef }) {
  const [open, setOpen] = useState(false);
  const [highlight, setHighlight] = useState(0);
  const [position, setPosition] = useState(null);
  const inputEl = useRef(null);
  const blurTimer = useRef(null);

  const matches = open ? filterInventoryOptions(options, value) : [];

  const syncPosition = useCallback(() => {
    const el = inputEl.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const dropdownHeight = 240;
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const showAbove = spaceBelow < dropdownHeight && spaceAbove > spaceBelow;
    const top = showAbove
      ? Math.max(10, rect.top - dropdownHeight - 4)
      : Math.min(window.innerHeight - dropdownHeight - 10, rect.bottom + 2);
    const width = Math.max(rect.width, 280);
    const left = Math.max(10, Math.min(rect.left, window.innerWidth - width - 10));

    setPosition({
      top,
      left,
      width,
      maxHeight: Math.min(256, Math.max(120, showAbove ? spaceAbove - 20 : spaceBelow - 20)),
    });
  }, []);

  // The tables live inside a fixed-height scroll card, so the list is portalled out to avoid being clipped.
  useEffect(() => {
    if (!open) return undefined;
    syncPosition();
    const handleViewportChange = () => syncPosition();
    window.addEventListener('scroll', handleViewportChange, true);
    window.addEventListener('resize', handleViewportChange);
    return () => {
      window.removeEventListener('scroll', handleViewportChange, true);
      window.removeEventListener('resize', handleViewportChange);
    };
  }, [open, syncPosition]);

  useEffect(() => {
    setHighlight(0);
  }, [value]);

  const attachRef = (el) => {
    inputEl.current = el;
    if (typeof inputRef === 'function') inputRef(el);
  };

  const choose = (option) => {
    if (!option) return;
    setOpen(false);
    onPick?.(option);
  };

  const handleFocus = () => {
    if (blurTimer.current) clearTimeout(blurTimer.current);
    syncPosition();
    setOpen(true);
  };

  const handleBlur = () => {
    blurTimer.current = setTimeout(() => {
      setOpen(false);
    }, 200);
  };

  const handleKeyDown = (e) => {
    if (!open || matches.length === 0) {
      if (e.key === 'ArrowDown') {
        syncPosition();
        setOpen(true);
        e.preventDefault();
      }
      return;
    }
    if (e.key === 'ArrowDown') {
      setHighlight((prev) => (prev + 1) % matches.length);
      e.preventDefault();
    } else if (e.key === 'ArrowUp') {
      setHighlight((prev) => (prev - 1 + matches.length) % matches.length);
      e.preventDefault();
    } else if (e.key === 'Enter') {
      if (matches[highlight]) {
        choose(matches[highlight]);
        e.preventDefault();
      }
    } else if (e.key === 'Escape') {
      setOpen(false);
      e.preventDefault();
    } else if (e.key === 'Tab') {
      if (open && matches[highlight] && value && matches.length > 0) {
        choose(matches[highlight]);
      } else {
        setOpen(false);
      }
    }
  };

  return (
    <div className="relative">
      <input
        disabled={disabled}
        id={id}
        name={name}
        className={tableCellInputClass}
        type="text"
        value={value || ''}
        onChange={(e) => {
          syncPosition();
          setOpen(true);
          onChange(e);
        }}
        onClick={() => {
          if (!open) {
            syncPosition();
            setOpen(true);
          }
        }}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder="Medicine name"
        autoComplete="off"
        ref={attachRef}
      />
      {open && position && matches.length > 0
        ? createPortal(
          <ul
            className={`fixed ${DROPDOWN_Z} overflow-auto rounded-md border border-gray-200 bg-white py-1 text-sm shadow-lg`}
            style={{
              top: position.top,
              left: position.left,
              width: position.width,
              maxHeight: position.maxHeight || 256,
            }}
            onMouseDown={(e) => e.preventDefault()}
          >
            {matches.map((option, index) => (
              <li key={option.key || `${option.name}-${option.potency}-${index}`}>
                <button
                  type="button"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    choose(option);
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    choose(option);
                  }}
                  onMouseEnter={() => setHighlight(index)}
                  className={`flex w-full items-start justify-between gap-3 px-2 py-1.5 text-left transition-colors ${index === highlight ? 'bg-primary-50' : 'bg-white hover:bg-gray-50'}`}
                >
                  <span className="min-w-0">
                    <span className="font-medium text-gray-900">{option.name}</span>
                    {option.potency ? <span className="ml-1 font-semibold text-primary-600">{option.potency}</span> : null}
                    {option.type || option.company ? (
                      <span className="block truncate text-[11px] text-gray-500">{[option.type, option.company].filter(Boolean).join(' · ')}</span>
                    ) : null}
                  </span>
                  <span className="shrink-0 text-right text-[11px] leading-tight">
                    {option.price !== null ? <span className="block text-gray-700">₹ {option.price}</span> : null}
                    <span className={option.stock > 0 ? 'text-gray-500' : 'text-red-500'}>{option.stock > 0 ? `${option.stock} left` : 'Out of stock'}</span>
                  </span>
                </button>
              </li>
            ))}
          </ul>,
          document.body,
        )
        : null}
    </div>
  );
}


// Record of the medicine couriered for this visit. Sits above the payment table and
// keeps its own fields, so nothing here feeds the amount calculations below it.
const COURIER_NAME_OPTIONS = ['DTDC', 'India Post'];

const CourierTable = ({ disabled, handleCourierChange, formData }) => {
  const labelCell = "px-3 py-1.5 text-gray-800 font-medium text-xs sm:text-sm";
  const valueCell = "px-2 py-1 w-[52%] border-l border-gray-200";
  const valueInput = "w-full rounded-md border border-gray-200 bg-white px-2 py-1 text-sm outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 disabled:bg-gray-50 disabled:text-gray-600";
  const selectClass = "w-full rounded-md border border-gray-200 bg-white px-2 py-1 text-sm text-slate-800 outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 disabled:bg-gray-50 disabled:text-gray-600";

  return (
    <div className="overflow-hidden rounded-lg border border-gray-300">
      <table className="w-full table-fixed text-sm">
        <thead>
          <tr className="text-center text-xs bg-primary-400 font-semibold text-primary-50 uppercase tracking-wider">
            <th colSpan={2} className="px-4 py-1.5">
              Courier Medicine Details
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          <tr>
            <td className={labelCell}>Name Of Courier</td>
            <td className={valueCell}>
              <select
                disabled={disabled}
                id={formData?.Date}
                name="courierName"
                onChange={handleCourierChange}
                className={selectClass}
                value={formData?.CourierDetails?.courierName || ""}
              >
                <option value="">Select Courier</option>
                {COURIER_NAME_OPTIONS.map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            </td>
          </tr>
          <tr>
            <td className={labelCell}>Date Of Courier</td>
            <td className={valueCell}>
              <input
                disabled={disabled}
                type="date"
                autoComplete="off"
                id={formData?.Date}
                name="courierDate"
                onChange={handleCourierChange}
                className={valueInput}
                value={formData?.CourierDetails?.courierDate || ""}
              />
            </td>
          </tr>
          <tr>
            <td className={labelCell}>Cost Of Courier</td>
            <td className={valueCell}>
              <input
                disabled={disabled}
                type="text"
                autoComplete="off"
                id={formData?.Date}
                name="courierCost"
                placeholder="Enter Cost"
                onChange={handleCourierChange}
                className={valueInput}
                value={formData?.CourierDetails?.courierCost || ""}
              />
            </td>
          </tr>
          <tr>
            <td className={labelCell}>Courier Tracking Id</td>
            <td className={valueCell}>
              <input
                disabled={disabled}
                type="text"
                autoComplete="off"
                id={formData?.Date}
                name="trackingId"
                placeholder="Enter Tracking Id"
                onChange={handleCourierChange}
                className={valueInput}
                value={formData?.CourierDetails?.trackingId || formData?.CourierDetails?.trackingNo || ""}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};


// The configured names, trimmed and de-duplicated ignoring case, plus the
// record's saved name if it is no longer on the list (renamed or deleted), so
// an old prescription never shows a blank choice.
const optionsWithSaved = (list, saved) => {
  const keyOf = (value) => String(value ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
  const byKey = new Map();
  (Array.isArray(list) ? list : []).forEach((item) => {
    const label = String(item ?? '').trim();
    if (label && !byKey.has(keyOf(label))) byKey.set(keyOf(label), label);
  });
  if (saved && String(saved).trim() && !byKey.has(keyOf(saved))) byKey.set(keyOf(saved), String(saved));
  return [...byKey.values()];
};

// Rows 1 and 2 of the "Others" block: a name picked from a DropDowns list.
// Row 3 keeps a free-text name.
const OPTION_ROWS = {
  1: { placeholder: 'Select Health Package', listKey: 'packageOptions' },
  2: { placeholder: 'Select Alternative Treatment', listKey: 'treatmentOptions' },
};

const PriceTable = ({ disabled, handelPriceTable, PaymentDetails, setFormData, formData, packageOptions, treatmentOptions }) => {
  const optionLists = { packageOptions, treatmentOptions };

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const inputs = document.querySelectorAll("tbody input:not([disabled])"); // all enabled inputs in tbody
      const index = Array.from(inputs).indexOf(e.target);
      if (index >= 0 && index < inputs.length - 1) {
        inputs[index + 1].focus(); // focus next input
      }
    }
  };


  // console.log("formData from price table", formData);
  const labelCell = "px-3 py-1.5 text-gray-800";
  const amountCell = "px-2 py-1 w-[34%] border-l border-gray-200";
  const amountInput = "w-full rounded-md border border-gray-200 bg-white px-2 py-1 text-right text-sm outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 disabled:bg-gray-50 disabled:text-gray-600";

  return (
    <div className="overflow-hidden rounded-lg border border-gray-300">
      <table className="w-full table-fixed text-sm">
        <thead>
          <tr className="text-center text-xs bg-primary-400 font-semibold text-primary-50 uppercase tracking-wider">
            <th colSpan={2} className="px-4 py-1.5">
              Payment Details
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {[
            ['consultation_charges', 'Consultation Charges'],
            ['followup_medicine_charges', 'Followup / Medicine Charges'],
            ['supplimentary_charges', 'Supplimentary Medicine Charges'],
          ].map(([field, label]) => (
            <tr key={field}>
              <td className={labelCell}>{label}</td>
              <td className={amountCell}>
                <input disabled={disabled} onKeyDown={handleEnterKey} type="text" autoComplete="off" id={formData?.Date} name={field} onChange={handelPriceTable} className={amountInput} value={formData?.PaymentDetails?.[field] || ""} />
              </td>
            </tr>
          ))}

          {[1, 2, 3].map((num) => (
            <tr key={num}>
              <td className="px-2 py-1">
                {OPTION_ROWS[num] ? (
                  <select
                    disabled={disabled}
                    id={formData?.Date}
                    name={`others_${num}_label`}
                    onChange={handelPriceTable}
                    aria-label={OPTION_ROWS[num].placeholder}
                    className={`w-full rounded-md border border-gray-200 bg-white px-1 py-1 text-sm outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 disabled:bg-gray-50 ${formData?.PaymentDetails?.[`others_${num}_label`] ? 'text-gray-800' : 'text-gray-400'}`}
                    value={formData?.PaymentDetails?.[`others_${num}_label`] || ""}
                  >
                    <option value="">{OPTION_ROWS[num].placeholder}</option>
                    {optionsWithSaved(optionLists[OPTION_ROWS[num].listKey], formData?.PaymentDetails?.[`others_${num}_label`]).map((name) => (
                      <option key={name} value={name} className="text-gray-800">
                        {name}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    disabled={disabled}
                    onKeyDown={handleEnterKey}
                    type="text"
                    autoComplete="off"
                    id={formData?.Date}
                    name={`others_${num}_label`}
                    placeholder={`Others ${num}`}
                    onChange={handelPriceTable}
                    className="w-full rounded-md border border-transparent bg-transparent px-1 py-1 text-sm outline-none placeholder:text-gray-400 hover:border-gray-200 focus:border-primary-400"
                    value={formData?.PaymentDetails?.[`others_${num}_label`] || ""}
                  />
                )}
              </td>
              <td className={amountCell}>
                <input
                  disabled={disabled}
                  onKeyDown={handleEnterKey}
                  type="text"
                  autoComplete="off"
                  id={formData?.Date}
                  name={`others_${num}`}
                  onChange={handelPriceTable}
                  className={amountInput}
                  value={formData?.PaymentDetails?.[`others_${num}`] || ""}
                />
              </td>
            </tr>
          ))}

          <tr>
            <td className={labelCell}>Previous Balance / Deposits</td>
            <td className={amountCell}>
              <input disabled={true} onKeyDown={handleEnterKey} type="text" autoComplete="off" id={formData?.Date} name="previous_balance_deposits" onChange={handelPriceTable} className={amountInput} value={formData?.PaymentDetails?.previous_balance_deposits || 0} />
            </td>
          </tr>

          <tr className="bg-primary-50 border-t-2 border-primary-300">
            <td className="px-3 py-2 font-bold text-gray-900">Total Payable Amount</td>
            <td className="px-3 py-2 w-[34%] border-l border-gray-200 text-right font-bold text-gray-900">
              ₹ {formData?.total || 0}
            </td>
          </tr>

          <tr>
            <td className={labelCell}>Amount Received</td>
            <td className={amountCell}>
              <input disabled={disabled} type="text" autoComplete="off" id={formData?.Date} name="paid" onChange={handelPriceTable} className={amountInput} value={formData?.PaymentDetails?.paid || ""} />
            </td>
          </tr>

          <tr className={Number(formData?.remaining) > 0 ? 'bg-red-50' : 'bg-green-50'}>
            <td className="px-3 py-2 font-bold text-gray-900">Remaining</td>
            <td className={`px-3 py-2 w-[34%] border-l border-gray-200 text-right font-bold ${Number(formData?.remaining) > 0 ? 'text-red-600' : 'text-green-700'}`}>
              ₹ {formData?.remaining || 0}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AddPrescription;
